export const AGREEMENT_INFO = {
  title: '개인정보 처리방침',
  content: /* html */ `
  <div class="personalInfoWrap terms">
  <p class="text"><strong>이 약관은 2025년 03월 11일부터 적용됩니다.</strong></p>
  <p class="text">
    프롭티어㈜(이하 “회사”라고 함)는 회사가 운영하는 서비스(aipartner.com, aipartner.net, aipartner.plus) 는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법, 통신비밀보호법,
    전기통신사업법 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거하여 다음과 같이 개인정보 처리방침을 정하여 이용자 권익 보호에 최선을
    다하고 있습니다.
  </p>
  <div class="labeling">
    <div class="tableWrap auto mb-0">
      <table class="va-t">
        <colgroup>
          <col width="33%" />
          <col width="33%" />
          <col width="33%" />
        </colgroup>
        <tbody>
          <tr>
            <th colspan="3">주요 개인정보 처리 표시(라벨링)</th>
          </tr>
          <tr>
            <td class="ta-c">
              <strong>개인정보 수집</strong>
              <p class="img">
                <img src="https://www.aipartner.com/image/terms_icon01.png" />
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 이름, 휴대폰번호, 비밀번호 등
              </p>
            </td>
            <td class="ta-c">
              <strong>개인정보 처리 목적</strong>
              <p class="img">
                <img src="https://www.aipartner.com/image/terms_icon02.png" />
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 이용자 식별, 회원관리, 온라인 문의, 매물등록 및 노출 관리, 상품 구매 등 회원제 서비스 제공, 부정 이용 방지
              </p>
            </td>
            <td class="ta-c">
              <strong>개인정보 보유기간</strong>
              <p class="img">
                <img src="https://www.aipartner.com/image/terms_icon03.png" />
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 탈퇴일로부터 1년
              </p>
            </td>
          </tr>
          <tr>
            <td class="ta-c">
              <strong>개인정보 제3자 제공</strong>
              <p class="img">
                <img src="https://www.aipartner.com/image/terms_icon04.png" />
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 네이버파이낸셜(네이버부동산)
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 매경닷컴(매경부동산)
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 신한은행(신한SOL)등
              </p>
            </td>
            <td class="ta-c">
              <strong>개인정보 처리 위탁</strong>
              <p class="img">
                <img src="https://www.aipartner.com/image/terms_icon05.png" />
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 비즈톡, SCI평가정보, 토스페이먼츠 등
              </p>
            </td>
            <td class="ta-c">
              <strong>개인정보 민원처리 담당부서</strong>
              <p class="img">
                <img src="https://www.aipartner.com/image/terms_icon06.png" />
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 고객센터: 1800-6950
              </p>
              <p class="text ta-l">
                <b class="dot">·</b> 이메일: help@proptier.co.kr
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="ta-r mt-8">※ 세부 항목은 개인정보 처리방침 본문 확인</p>
  </div>

  <div class="tableWrap auto">
    <table>
      <colgroup>
        <col width="13%" />
        <col width="37%" />
        <col width="13%" />
        <col width="37%" />
      </colgroup>
      <tbody>
        <tr>
          <th colspan="4">목차</th>
        </tr>
        <tr>
          <td class="ta-c">
            <i class="terms-icon terms-icon01"></i>
            <i class="terms-icon terms-icon02"></i>
            <i class="terms-icon terms-icon03"></i>
          </td>
          <td>1. 개인정보의 처리목적, 수집 항목, 보유 및 이용기간</td>
          <td class="ta-c">
            <i class="terms-icon terms-icon10"></i>
          </td>
          <td>7. 개인정보의 안전성 확보조치</td>
        </tr>
        <tr>
          <td class="ta-c"></td>
          <td>2. 개인정보 수집방법</td>
          <td class="ta-c">
            <i class="terms-icon terms-icon04"></i>
          </td>
          <td>8. 개인정보 자동 수집 장치의 사용 및 거부에 관한 사항</td>
        </tr>
        <tr>
          <td class="ta-c">
            <i class="terms-icon terms-icon07"></i>
          </td>
          <td>3. 개인정보의 파기 절차 및 방법</td>
          <td class="ta-c">
            <i class="terms-icon terms-icon12"></i>
            <i class="terms-icon terms-icon11"></i>
          </td>
          <td>9. 개인정보 보호책임자 및 고충처리 담당부서</td>
        </tr>
        <tr>
          <td class="ta-c">
            <i class="terms-icon terms-icon08"></i>
          </td>
          <td>4. 이용자 및 법정대리인의 권리와 그 행사방법</td>
          <td class="ta-c">
            <i class="terms-icon terms-icon13"></i>
          </td>
          <td>10. 권익침해 구제방법</td>
        </tr>
        <tr>
          <td class="ta-c">
            <i class="terms-icon terms-icon05"></i>
          </td>
          <td>5. 개인정보의 제3자 제공</td>
          <td class="ta-c"></td>
          <td>11. 기타</td>
        </tr>
        <tr>
          <td class="ta-c">
            <i class="terms-icon terms-icon06"></i>
          </td>
          <td>6. 개인정보처리의 위탁</td>
          <td class="ta-c">
            <i class="terms-icon terms-icon09"></i>
          </td>
          <td>12. 개인정보 처리방침 변경에 관한 사항</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="tit">
    <strong>1. 개인정보의 처리목적, 수집 항목, 보유 및 이용기간</strong>
    <div class="label-wrap">
      <i class="terms-icon terms-icon01"></i>
      <i class="terms-icon terms-icon02"></i>
      <i class="terms-icon terms-icon03"></i>
    </div>
  </div>

  <ol>
    <li>
        <p class="text">① 회사는 개인정보를 다음 목적을 위해 처리하며, 수집된 개인정보는 명시된 목적 이외의 용도로 이용되지 않습니다. 이용 목적이 변경될 경우, 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 취할 예정입니다</p>
    </li>
    <li>
      <div class="tableWrap auto">
        <table>
          <colgroup>
            <col width="10%" />
            <col width="13%" />
            <col width="26%" />
            <col width="7%" />
            <col width="28%" />
            <col width="16%" />
          </colgroup>
          <tbody>
            <tr>
                <th colspan="6">공통 (통합회원)</th>
            </tr>
            <tr align="center">
                <th>구분</th>
                <th>개인정보 처리업무</th>
                <th>수집 목적</th>
                <th colspan="2">수집 항목</th>
                <th>보유 및 이용기간</th>
            </tr>
            <tr>
                <td rowspan="9">홈페이지/모바일</td>
                <td>회원가입<br />(개인 회원)</td>
                <td>이용자 식별, 회원관리, 온라인 문의 등 회원제 서비스 제공, 부정 이용 방지</td>
                <td>필수</td>
                <td>이름, 휴대폰번호, 비밀번호</td>
                <td>탈퇴일로부터 1년</td>
            </tr>
            <tr>
                <td>SNS계정으로 회원가입</td>
                <td>이용자 식별, 회원관리, 모임관리, 게시글 등록, 매물 공유 등 회원제 서비스 제공, 부정 이용 방지</td>
                <td>필수</td>
                <td>휴대폰번호, 이메일주소, CI(연계정보), 프로필정보 (닉네임, 프로필사진), 생년월일, 이름, 성별</td>
                <td>탈퇴일로부터 1년</td>
            </tr>
            <tr>
                <td>본인인증</td>
                <td>휴대폰 본인인증</td>
                <td>필수</td>
                <td>본인인증 시 수집되는 정보(이름, 휴대폰번호, 생년월일, CI, DI)</td>
                <td>탈퇴일로부터 1년</td>
            </tr>
            <tr>
                <td>전화문의</td>
                <td>녹취이력 관리</td>
                <td>필수</td>
                <td>발신번호, 녹취데이터</td>
                <td>녹취일로부터 6개월</td>
            </tr>
            <tr>
                <td rowspan="2">내정보 관리</td>
                <td>회원 프로필 사진 등록</td>
                <td>선택</td>
                <td>프로필사진</td>
                <td>회원 탈퇴 또는 동의 철회 시까지</td>
            </tr>
            <tr>
                <td>회원 닉네임 등록</td>
                <td>선택</td>
                <td>닉네임</td>
                <td>회원 탈퇴 또는 동의 철회 시까지</td>
            </tr>
            <tr>
                <td>마케팅 목적 개인정보 수집 및 이용 동의</td>
                <td>1) 고객/개인별 맞춤 서비스, 통계학적 특성에 따른 서비스 제공 및 광고를 게재하기 위한 자료로 활용
                    <br />
                    2) 접속 빈도 파악 또는 회원의 본 서비스 이용과 관련된 통계 자료로 활용
                    <br />
                    3) 서비스의 유효성 확인, 이벤트 참여 기회 제공, 설문조사
                </td>
                <td>선택</td>
                <td>이름, 연락처, 이메일 주소</td>
                <td>회원 탈퇴 또는 동의 철회 시까지</td>
            </tr>
            <tr>
                <td>광고성 정보 수신</td>
                <td>신규 서비스 관련 소식, 이벤트, 본 서비스 관련 소식 등 광고성 정보 전송</td>
                <td>선택</td>
                <td>이메일주소, 휴대폰번호</td>
                <td>회원 탈퇴 또는 동의 철회 시까지</td>
            </tr>
            <tr>
                <td>자동 생성</td>
                <td>서비스 이용에 대한 기록</td>
                <td colspan="2">IP 주소, 서비스 이용기록</td>
                <td>통신사실확인자료: 3개월</td>
            </tr>
            <tr>
                <td>홈페이지</td>
                <td>온라인 문의</td>
                <td>온라인 1:1 문의</td>
                <td>필수</td>
                <td>문의내용</td>
                <td>문의접수일로부터 3년</td>
            </tr>
            <tr>
                <td>콜센터</td>
                <td>전화 문의</td>
                <td>상담이력 관리</td>
                <td>필수</td>
                <td>회원구분, 아이디, 이름, 상호명, 전화번호, 휴대폰번호, 사업자등록번호</td>
                <td>문의접수일로부터 3년</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="tableWrap auto">
        <table>
          <colgroup>
            <col width="10%" />
            <col width="13%" />
            <col width="26%" />
            <col width="7%" />
            <col width="28%" />
            <col width="16%" />
          </colgroup>
          <tbody>
            <tr>
                <th colspan="6">공통 (비회원)</th>
            </tr>
            <tr align="center">
              <th>구분</th>
              <th>개인정보 처리업무</th>
              <th>수집 목적</th>
              <th colspan="2">수집 항목</th>
              <th>보유 및 이용기간</th>
            </tr>
            <tr>
              <td rowspan="2">홈페이지/모바일</td>
              <td>이실장 가입 상담 문의</td>
              <td>이실장 서비스 관련 안내 및 상담 제공</td>
              <td>필수</td>
              <td>상호명, 중개사명, 소재지, 개설등록번호, 휴대폰번호</td>
              <td>문의 접수일로부터 3개월</td>
            </tr>
            <tr>
              <td>안심케어 서비스 제공</td>
              <td>안심케어 서비스 관련 안내</td>
              <td>필수</td>
              <td>거래 희망 지역, 이름, 휴대폰번호</td>
              <td>수집일로부터 1개월까지</td>
            </tr>
          </tbody>
        </table>
      </div>
            
      <div class="tableWrap auto">
        <table>
          <colgroup>
            <col width="10%" />
            <col width="13%" />
            <col width="26%" />
            <col width="7%" />
            <col width="28%" />
            <col width="16%" />
          </colgroup>
          <tbody>
            <tr>
                <th colspan="6">이실장</th>
            </tr>
            <tr align="center">
                <th>구분</th>
                <th>개인정보 처리업무</th>
                <th>수집 목적</th>
                <th colspan="2">수집 항목</th>
                <th>보유 및 이용기간</th>
            </tr>
            <tr>
                <td rowspan="15">홈페이지/모바일</td>
                <td>회원가입<br />(중개업소 회원)</td>
                <td>이용자 식별, 회원관리, 온라인 문의, 매물등록 및 노출 관리, 상품 구매 등 회원제 서비스 제공, 부정 이용 방지</td>
                <td>필수</td>
                <td>사업자등록번호, 개설등록번호, 사업장명, 사업장 주소, 광고 노출 전화번호, 광고 노출 휴대폰번호, 중개사무소 등록증 사본(이름, 생년월일, 중개사무소 명칭, 중개사무소 소재지, 등록인장), 사업자등록증 사본(상호, 이름, 생년월일, 사업장 소재지)</td>
                <td>탈퇴일로부터 1년</td>
            </tr>
            <tr>
                <td>회원 전환</td>
                <td>개인회원에서 중개업소회원으로 전환</td>
                <td>필수</td>
                <td>사업자등록번호, 개설등록번호, 사업장명, 사업장 주소, 광고 노출 전화번호, 광고 노출 휴대폰번호, 중개사무소 등록증 사본(이름, 생년월일, 중개사무소 명칭, 중개사무소 소재지, 등록인장), 사업자등록증 사본(상호, 이름, 생년월일, 사업장 소재지)</td>
                <td>탈퇴일로부터 1년</td>
            </tr>
            <tr>
                <td>통화저장 품질향상을 위한 데이터 수집 동의</td>
                <td>통화 저장 품질 향상을 위한 연구 데이터 활용, 이실장 성능 향상</td>
                <td>선택</td>
                <td>이용자가 건별로 동의한 통화의 녹음 파일, 이실장 이용기록(음성, 편집 데이터, 등록단어)</td>
                <td>통화 품질 향상을 위한 녹음 파일은 7일 이내 비식별 처리하여 5년간 보관 후 파기</td>
            </tr>
            <tr>
                <td>AI전화비서</td>
                <td>AI전화비서 사용을 위한 정보 및 음성데이터 처리</td>
                <td>선택</td>
                <td>이용자가 건별로 동의한 통화의 이름, 연락처, 녹음파일, 이실장이용기록(음성, 편집데이터, 등록단어)</td>
                <td>회원탈퇴 또는 통화내역 삭제 시</td>
            </tr>
            <tr>
                <td>멤버관리</td>
                <td>멤버초대</td>
                <td>선택</td>
                <td>이름, 연락처, 자격</td>
                <td>1) 멤버 등록 정보<br />멤버삭제 또는 회원탈퇴 시<br />
                    2) 멤버 초대 이력<br />회원탈퇴 시
                </td>
            </tr>
            <tr>
                <td rowspan="4">고객관리</td>
                <td>중개업소의 고객등록</td>
                <td>필수</td>
                <td>이름, 연락처, 성별, 별칭, 네이버ID, 거주지, 상호</td>
                <td>회원탈퇴 또는 고객삭제 시</td>
            </tr>
            <tr>
                <td>중개업소의 일정관리</td>
                <td>선택</td>
                <td>이름, 연락처</td>
                <td>회원탈퇴 또는 일정삭제 시</td>
            </tr>
            <tr>
                <td>중개업소의 상담관리</td>
                <td>필수</td>
                <td>이름, 연락처, 성별, 상담내용</td>
                <td>회원탈퇴 또는 상담내역 삭제 시</td>
            </tr>
            <tr>
                <td>중개업소의 고객맞춤매물 관리</td>
                <td>필수</td>
                <td>이름, 연락처</td>
                <td>회원탈퇴 또는 고객맞춤매물 삭제 시</td>
            </tr>
            <tr>
                <td>매물관리</td>
                <td>매물 접수 관리</td>
                <td>필수</td>
                <td>고객명, 고객 연락처, 매물주소</td>
                <td>회원탈퇴 또는 매물등록 삭제 시</td>
            </tr>
            <tr>
                <td rowspan="3">임장활동</td>
                <td>내 관리 호실 등록</td>
                <td>필수</td>
                <td>동/호, 고객명, 연락처</td>
                <td>회원탈퇴 시 즉시 파기</td>
            </tr>
            <tr>
                <td>고객/점유 정보 등록</td>
                <td>필수</td>
                <td>소유자정보(소유자명, 연락처), 거주자정보(거주자명, 관계, 연락처), 기타관계자정보(관계자명, 관계, 연락처)</td>
                <td>회원탈퇴 시 즉시 파기</td>
            </tr>
            <tr>
                <td>매물 상담 정보 등록</td>
                <td>필수</td>
                <td>고객명, 연락처, 상담내용</td>
                <td>회원탈퇴 시 즉시 파기</td>
            </tr>
            <tr>
                <td>사진관리</td>
                <td>집찍고 서비스 이용</td>
                <td>필수</td>
                <td>집찍고 앱 촬영사진, 메타데이터(위치정보), 주소, 거주자 요청 촬영 사진</td>
                <td>서비스해지로부터 60일 </td>
            </tr>
            <tr>
                <td>위치기반서비스 </td>
                <td>집찍고 촬영 사진의 주소기반 정렬 및 매물 전송을 위한 위치정보</td>
                <td>선택</td>
                <td>집찍고 앱을 이용한 사진 촬영 시 사진파일 내 GPS위치 정보</td>
                <td>조회 후 6개월 까지</td>
            </tr>
            <tr>
                <td rowspan="12">홈페이지</td>
                <td rowspan="2">결제관리</td>
                <td>충전금 간편결제 카드 등록</td>
                <td>필수</td>
                <td>카드번호, 카드사명</td>
                <td>카드삭제 또는 회원탈퇴 시</td>
            </tr>
            <tr>
                <td>상품 단말기(페이나우비즈. 페이앳) 결제</td>
                <td>필수</td>
                <td>카드번호, 카드사명</td>
                <td>결제일로부터 5년</td>
            </tr>
            <tr>
                <td>환불관리</td>
                <td>(카드 환불 불가 시)<br />충전금 환불, 멤버십 환불, 안심케어 프리미엄 환불, 집찍고 환불, 아파트아이 상품 환불</td>
                <td>필수</td>
                <td>환불 계좌정보(예금주명, 은행명, 계좌번호)</td>
                <td>환불일로부터 5년</td>
            </tr>
            <tr>
                <td rowspan="9">매물관리</td>
                <td>매물 광고 등록</td>
                <td>필수</td>
                <td>중개업소 대표자명 또는 소속 공인중개사명, 전화번호, 개설등록번호, 중개업소 소재지</td>
                <td>허위매물 등록 이력 확인을 위해 매물 노출종료일 또는 거래종료일로부터 1년(매물등록 실패 건: 익일 즉시 파기)</td>
            </tr>
            <tr>
                <td rowspan="2">- 매경부동산 사이트에 매물정보 홍보, 허위매물 등록 방지<br />
                    - 제휴사인 ‘네이버파이낸셜’에 부동산 진성 매물 등록을 위한 확인 정보 제공
                    (홍보확인서)</td>
                <td>필수</td>
                <td>소유자명, 소유자와의 관계, 매물소재지, 거래유형, 가격</td>
                <td rowspan="2">허위매물 등록 이력 확인을 위해 매물 노출종료일 또는 거래완료일로부터 1년(매물등록 실패 건 : 익일 즉시 파기)</td>
            </tr>
            <tr>
                <td>선택</td>
                <td>소유자 휴대전화번호</td>
            </tr>
            <tr>
                <td>제휴사인 ‘네이버 파이낸셜’에 부동산 진성 매물 등록을 위한 확인정보 제공
                    (신홍보확인서)</td>
                <td>필수</td>
                <td>
                    소유자명, 소재지, 소유자 전화번호, 네이버ID<br />
                    - 위임장에 의한 처리일 경우 : 위임자 정보(이름, 주민등록번호 앞7자리, 주소, 위임받는 자와의 관계,
                    인감), 위임받는자 정보(이름, 주민등록번호 앞7자리, 주소)<br />
                    - 분양계약서에 의한 처리일 경우 : 이름, 주소, 인감<br />
                    - 명함에 의한 처리일 경우 : 이름, 소속회사, 직함, 전화번호, 이메일<br />
                    - 재직증명서에 의한 처리일 경우 : 이름, 소속회사, 직함, 재직여부<br />
                    - 여권/외국인등록증 등에 의한 처리일 경우 : 이름, 국적<br />
                    - 전세계약서/전입신고확인서 등에 의한 처리일 경우 : 이름, 주소
                </td>
                <td>허위매물 등록 이력 확인을 위해 매물 노출종료일 또는 거래완료일로부터 1년(매물등록 실패 건 : 익일 즉시 파기)</td>
            </tr>
            <tr>
                <td>- 매경부동산 사이트에 매물정보 홍보, 허위매물 등록 방지<br />
                    - 제휴사인 ‘네이버파이낸셜’에 부동산 진성 매물 등록을 위한 확인 정보 제공
                    (전화확인)</td>
                <td>필수</td>
                <td>소유자(의뢰인)명, 소유자(의뢰인) 연락처, 소재지, 거래유형, 가격</td>
                <td>허위매물 등록 이력 확인을 위해 매물 노출종료일 또는 거래완료일로부터 1년(매물등록 실패 건 : 익일 즉시 파기)</td>
            </tr>
            <tr>
                <td>- 매경부동산 사이트에 매물정보 홍보, 허위매물 등록 방지<br />
                    - 제휴사인 ‘네이버파이낸셜’에 부동산 진성 매물 등록을 위한 확인 정보 제공 (현장확인1, 현장확인2)
                </td>
                <td>필수</td>
                <td>소유자(의뢰인)명, 소유자(의뢰인) 연락처, 소재지, 거래유형, 가격</td>
                <td>허위매물 등록 이력 확인을 위해 매물 노출종료일 또는 거래완료일로부터 1년(매물등록 실패 건 : 익일 즉시 파기)</td>
            </tr>
            <tr>
                <td>- 매경부동산 사이트에 매물정보 홍보, 허위매물 등록 방지<br />
                    - 제휴사인 ‘네이버파이낸셜’에 부동산 진성 매물 등록을 위한 확인 정보 제공
                    (모바일확인V1)</td>
                <td>필수</td>
                <td>- 공통 : 소재지, 거래유형, 가격<br />
                    - 개인명의 : 소유자명, 소유자 휴대폰번호, 등기부등본(소유자명, 생년월일, 주소 / 등기부등본 첨부 시)<br />
                    - 분양권 : 분양계약서(매수인명, 생년월일, 주소), 매수인 휴대폰번호<br />
                    - 법인명의 : 의뢰인명(법인명의), 의뢰인 휴대폰번호(법인명의), 소유자와의 관계(법인명의), 등기부등본(소유자명, 생년월일, 주소 / 등기부등본 첨부 시)
                </td>
                <td>허위매물 등록 이력 확인을 위해 매물 노출종료일 또는 거래완료일로부터 1년(매물등록 실패 건 : 익일 즉시 파기)</td>
            </tr>
            <tr>
                <td>- 매경부동산 사이트에 매물정보 홍보, 허위매물 등록 방지<br />
                    - 제휴사인 ‘네이버파이낸셜’에 부동산 진성 매물 등록을 위한 확인 정보 제공
                    (모바일확인V2)</td>
                <td>필수</td>
                <td>성별, 휴대전화번호, 가입한 이동통신사, 등기부등본(소유자명, 생년월일, 주소) , 소재지, 거래유형, 가격</td>
                <td>허위매물 등록 이력 확인을 위해 매물 노출종료일 또는 거래완료일로부터 1년(매물등록 실패 건 : 익일 즉시 파기)</td>
            </tr>
            <tr>
                <td>매경부동산 사이트에 매물정보 홍보, 허위매물 등록 방지<br />
                    - 제휴사인 ‘네이버파이낸셜’에 부동산 진성 매물 등록을 위한 확인 정보 제공
                    (모바일확인V2-로켓등록)</td>
                <td>필수</td>
                <td>성별, 휴대전화번호, 가입한 이동통신사, 등기부등본(소유자명, 생년월일, 주소), 소재지, 거래유형, 가격</td>
                <td>허위매물 등록 이력 확인을 위해 매물 노출종료일 또는 거래완료일로부터 1년(매물등록 실패 건 : 익일 즉시 파기)</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="tableWrap auto">
        <table>
          <colgroup>
            <col width="10%" />
            <col width="13%" />
            <col width="26%" />
            <col width="7%" />
            <col width="28%" />
            <col width="16%" />
          </colgroup>
          <tbody>
            <tr>
              <th colspan="6">이실장 넷</th>
            </tr>
            <tr align="center">
                <th>구분</th>
                <th>개인정보 처리업무</th>
                <th>수집 목적</th>
                <th colspan="2">수집 항목</th>
                <th>보유 및 이용기간</th>
            </tr>
            <tr>
                <td rowspan="3">홈페이지/모바일</td>
                <td>중개사 인증</td>
                <td>중개사 인증</td>
                <td>필수</td>
                <td>중개업소정보(상호명, 주소, 대표자명, 개설등록번호, 사업자등록번호, 중개업소 대표 전화번호)</td>
                <td>탈퇴일로부터 1년</td>
            </tr>
            <tr>
                <td rowspan="2">공유매물관리</td>
                <td>공유매물 등록 시 고객정보 입력</td>
                <td>선택</td>
                <td>고객정보(고객명, 연락처, 소유자와의 관계)</td>
                <td>회원탈퇴 또는 매물 삭제 시</td>
            </tr>
            <tr>
                <td>구합니다 등록 시 고객정보 입력</td>
                <td>선택</td>
                <td>고객정보(고객명, 연락처, 소유자와의 관계)</td>
                <td>회원탈퇴 또는 매물 삭제 시</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="tableWrap auto">
        <table>
          <colgroup>
            <col width="10%" />
            <col width="13%" />
            <col width="26%" />
            <col width="7%" />
            <col width="28%" />
            <col width="16%" />
          </colgroup>
          <tbody>
            <tr>
              <th colspan="6">이실장 플러스(뉴렌트)</th>
            </tr>
            <tr align="center">
                <th>구분</th>
                <th>개인정보 처리업무</th>
                <th>수집 목적</th>
                <th colspan="2">수집 항목</th>
                <th>보유 및 이용기간</th>
            </tr>
            <tr>
                <td rowspan="3">홈페이지/모바일</td>
                <td rowspan="2">뉴렌트 서비스</td>
                <td>뉴렌트 서비스 계약∙이용 상담</td>
                <td>필수</td>
                <td>개인정보(성명, 유∙뮤선 전화번호, 소유 및 관리 부동산의 주소)</td>
                <td>뉴렌트 서비스 계약∙이용 상담 종료 시부터 1년</td>
            </tr>
            <tr>
                <td>- 보증금 한도 조회 서비스 제공<br />- 뉴렌트 임대차 계약 지원 서비스 제공</td>
                <td>필수</td>
                <td>- 본인식별정보 (Safe key, 암호화된 코드값) <br />- 신용관련정보 (채무불이행정보, 거래개설정보, 소득추정정보, 신용평가정보, 개인회생등록정보 및 기타 본인의 신용을 판단할 수 있는 정보)</td>
                <td>보증금 조회 후 60일까지,<br />단 임대차계약 시 체결일로부터 5년까지 </td>
            </tr>
            <tr>
                <td>위치기반서비스</td>
                <td>위치기반 부동산정보 안내</td>
                <td>선택</td>
                <td>지도 내 내위치 확인 시 위치정보</td>
                <td>회원 탈퇴 또는 동의 철회 시까지</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tableWrap auto">
        <table cellpadding="0" cellspacing="0">
            <colgroup>
                <col width="10%">
                <col width="20%">
                <col width="20%">
                <col width="10%">
                <col width="20%">
                <col width="20%">
            </colgroup>
            <tr>
                <th colspan="6">이실장 플러스(이실장)</th>
            </tr>
            <tr align="center">
                <th>구분</th>
                <th>개인정보 처리업무</th>
                <th>수집 목적</th>
                <th colspan="2">수집 항목</th>
                <th>보유 및 이용기간</th>
            </tr>
            <tr>
                <td rowspan="2">홈페이지/모바일</td>
                <td>이실장 서비스</td>
                <td>이용자 식별</td>
                <td>필수</td>
                <td>모바일기기 식별번호(SSAID, UUID)</td>
                <td>회원 탈퇴 또는 동의 철회 시까지</td>
            </tr>
            <tr>
                <td>위치기반서비스</td>
                <td>현재 위치기반 주변 정보 제공</td>
                <td>선택</td>
                <td>지도 내 내위치 확인 시 위치정보</td>
                <td>회원 탈퇴 또는 동의 철회 시까지</td>
            </tr>
        </table>
      </div>
    </li>
    <li>
        <p class="text">② 회사는 회원 서비스 제공을 위해 필요한 개인정보를 수집하며, 이는 회원의 동의를 기반으로 합니다. 회원은 선택적으로 동의를 거부할 수 있으나, 필수 항목에 대한 동의를 거부할 경우 서비스 이용에 제한이 있을 수 있습니다.</p>
        <p class="text">③ 회사는 법령에 따른 개인정보 보유 및 이용기간 또는 회원으로부터 개인정보를 수집 시에 동의 받은 개인정보 보유 및 이용기간 내에서 개인정보를 처리, 보유합니다.</p>
        <p class="text">④ 회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 개인위치정보 수집·이용·제공사실 확인자료를 자동으로 기록 보존하며 해당 자료는 6개월간 보관합니다.</p>
        <p class="text">⑤ 서비스의 이용 과정이나 사업처리 과정에서 다음과 같은 정보들이 자동으로 생성되어 수집될 수 있습니다. <br />
        - IP주소, 쿠키, 접속로그, 서비스 이용 기록, 불량 이용 기록, 방문 일시</p>
        <p class="text">⑥ 회사는 만 14 세 미만 아동의 개인정보 보호를 위하여 만 14세 이상의 이용자에 한해서 서비스(회원가입 등)를 제공하는 것을 원칙으로 합니다.</p>
        <p class="text">⑦ 회원이 탈퇴하거나 자격을 상실할 경우에는 회원의 별도 요청이 없더라도 수집된 회원정보를 삭제 및 파기합니다. 단, 회원의 탈퇴 또는 자격상실에도 불구하고 관계법령에 의해 보존하는 경우는 다음과 같습니다.</p>
    </li>
    <li>
      <div class="tableWrap">
        <table>
          <colgroup>
            <col width="40%" />
            <col width="44%" />
            <col width="16%" />
          </colgroup>
          <tbody>
            <tr align="center">
              <th>관계법령</th>
              <th>개인정보</th>
              <th>보존기간</th>
            </tr>
            <tr>
              <td rowspan="4">전자상거래 등에서의 소비자 보호에 관한 법률</td>
              <td>계약 또는 청약철회 등에 관한 기록</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>대금결제 및 재화 등의 공급에 관한 기록</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>소비자의 불만 또는 분쟁 처리에 관한 기록</td>
              <td>3년</td>
            </tr>
            <tr>
              <td>표시·광고에 관한 기록</td>
              <td>6개월</td>
            </tr>
            <tr>
              <td>국세기본법</td>
              <td>세법이 규정하는 모든 거래에 관한 장부 및 증빙서류</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>통신비밀보호법</td>
              <td>이용자의 인터넷 등 로그 기록</td>
              <td>3개월</td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>
  </ol>
  <p class="tit">
    <strong>2. 개인정보 수집방법</strong>
  </p>
  <ol>
    <li>
      <b>① 회사는 다음과 같은 방법으로 개인정보를 수집합니다.</b>
      <ol>
        <li>1) 웹페이지, 서면양식, 팩스, 고객센터 통화상담, 전화, 상담 게시판, 온라인 상담, 이메일, 이벤트 응모</li>
        <li>2) 협력회사로부터의 제공</li>
        <li>3) 생성정보 수집 툴을 통한 수집</li>
      </ol>
    </li>
  </ol>
  <p class="tit">
    <strong>3. 개인정보의 파기 절차 및 방법</strong> <i class="terms-icon terms-icon07"></i>
  </p>
  <ol>
    <li>① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 개인정보를 파기합니다.</li>
    <li>
      ② 이용자로부터 동의받은 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 다른 회원의 개인정보와 분리하여 보관합니다.
    </li>
    <li>
      ③ 개인정보 파기 절차 및 방법은 다음과 같습니다.
      <ol>
        <li>
          1) 파기절차
          <p class="text">회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.</p>
        </li>
        <li>
          2) 파기방법
          <p class="text">
            회사는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 복원할 수 없는 기술적 방법을 이용하여 파기하며, 종이 문서에 기록된 개인정보는 분쇄기로 분쇄하여 파기합니다.
          </p>
        </li>
      </ol>
    </li>
  </ol>
  <p class="tit">
    <strong>4. 이용자 및 법정대리인의 권리와 그 행사방법</strong> <i class="terms-icon terms-icon08"></i>
  </p>
  <ol>
    <li>
      ① 이용자는 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
      <ol>
        <li>1) 개인정보 열람요구</li>
        <li>2) 오류 등이 있을 경우 정정 요구</li>
        <li>3) 삭제요구</li>
        <li>4) 처리정지 요구</li>
        <li>5) 동의 철회 요구</li>
      </ol>
    </li>
    <li>
      ② 이용자의 개인정보 조회 및 수정을 위해서는 '개인정보변경'(또는 '회원정보수정' )을, 가입해지(동의철회)를 위해서는 "회원탈퇴"를, 각 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정
      또는 탈퇴가 가능합니다. 혹은 개인정보 보호책임자 및 담당자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다.
    </li>
    <li>
      ③ 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는, 회사는 당해 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한
      경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
    </li>
    <li>
      ④ 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 본 방침 “1. 개인정보의 처리목적, 수집 항목, 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수
      없도록 처리하고 있습니다.
    </li>
    <li>
      ⑤ 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
    </li>
    <li>⑥ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.</li>
    <li>⑦ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다. </li>
    <li>⑧ 회사는 이용자 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</li>
    <li>⑨ 이용자는 「개인정보 보호법」 등 기타 정보보호 및 개인정보 관련 법률을 준수하여야 합니다.</li>
  </ol>
  <p class="tit">
    <strong>5. 개인정보의 제3자 제공</strong> <i class="terms-icon terms-icon05"></i>
  </p>
  <ol>
    <li>
      ① 회사는 이용자의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만
      개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.<br />
      ※ 회원이 신청 또는 선택한 서비스의 세부 내용에 따라 개인정보를 관련 제 3자에게 제공합니다.<br />
      [예시] 분양 상담 및 정보 제공 서비스: 분양시행사, 분양시공사, 분양대행사, 광고대행사
    </li>
    <li>② 회사는 아래와 같이 고객의 개인정보를 제3자에게 제공하고 있습니다.</li>
    <li>
      <div class="tableWrap">
        <table>
          <colgroup>
            <col width="12%" />
            <col width="30%" />
            <col width="30%" />
            <col width="30%" />
          </colgroup>
          <tbody>
            <tr>
              <th>제공받는자</th>
              <th>제공받는 목적</th>
              <th>제공하는 개인정보 항목</th>
              <th>보유 및 이용기간</th>
            </tr>
            <tr>
              <td>
                매경닷컴
                <br />
                (매경부동산)
              </td>
              <td>매경부동산 매물광고 홍보 및 노출</td>
              <td>매물소재지, 중개사정보(회사명, 성명, 휴대전화번호, 주소)</td>
              <td>제공받은 개인정보를 60일간 보관</td>
            </tr>
            <tr>
              <td>
                KB국민은행
                <br />
                (KB부동산)
              </td>
              <td>KB부동산 매물광고 홍보 및 노출</td>
              <td>매물소재지, 중개사정보(회사명, 성명, 휴대전화번호, 주소)</td>
              <td>제공받은 개인정보를 60일간 보관</td>
            </tr>
            <tr>
              <td>나이스평가정보㈜</td>
              <td>
                - 개인 신용도 평가 (채무불이행정보, 거래개설정보, 소득추정정보, 개인회생등록정보 등 신용판단정보, 신용등급 확인)<br />
                - 실명확인<br />
                - 주민번호 대체키 발급 등 신용정보회사의 업무
              </td>
              <td>성명, 생년월일, 성별, 중복가입식별정보</td>
              <td>신용정보 조회 달성 시까지,<br />단, 관련법령에 따라 보존 의무가 있는 경우에는 보존기간까지 보관</td>
            </tr>
            <tr>
              <td rowspan="2">뉴렌트 중개사<br />(뉴렌트 거래를 중개하는 중개사에 한함)</td>
              <td>뉴렌트 맞춤 매물 제공</td>
              <td>성명, 휴대전화번호</td>
              <td>보증금 조회 후 60일까지</td>
            </tr>
            <tr>
              <td>
                - 뉴렌트 임대차 계약 체결 가능여부 확인<br />
                - 뉴렌트 임대차 계약 지원 서비스 제공
              </td>
              <td>성명, 뉴렌트를 통해 조회한 본인의 보증금 한도 정보</td>
              <td>제공 목적 달성시까지 (제공 후 24시간 까지)</td>
            </tr>
            <tr>
              <td rowspan="7">네이버파이낸셜 (네이버부동산)</td>
              <td rowspan="2">
                [홍보확인서]
                <br />
                - 네이버 부동산에 매물정보 홍보, 허위매물 등록 방지
                <br />
                - 상기 수집한 개인정보를 활용하여, 네이버 회원정보에 저장된 개인정보(이름, 휴대전화번호)와의 일치여부 확인을 통해 진성 매물 확인을 위한 기준으로 이용
                <br />
                - 네이버 부동산 서비스에 매물 등록 완료 후, 휴대전화번호로 안내 문자 발송
                <br />
                - 소유자명과 휴대전화번호는 지속 반복적인 허위 매물 등록 방지를 위해 활용
                <br />
                - 네이버 부동산에 매물정보 홍보, 허위매물 등록 방지
                <br />
                - 상기 수집한 개인정보를 활용하여, 네이버 회원정보에 저장된 개인정보(이름, 휴대전화번호)와의 일치여부 확인을 통해 진성 매물 확인을 위한 기준으로 이용
                <br />
                - 네이버 부동산 서비스에 매물 등록 완료 후, 휴대전화번호로 안내 문자 발송
                <br />
                - 소유자명과 휴대전화번호는 지속 반복적인 허위 매물 등록 방지를 위해 활용
                <br />
              </td>
              <td>소유자명, 소유자와의 관계, 소재지, 거래유형, 가격</td>
              <td rowspan="2">제공받은 개인정보를 60일간 보관하며 등기부등본, 소유자명과 휴대전화번호 는 안전한 부동산 거래 및 허위 매물 방지를 위하여 1년간 보관</td>
            </tr>
            <tr>
              <td>(선택)소유자 휴대전화번호</td>
            </tr>
            <tr>
              <td>
                [신홍보확인서]
                <br />
                - 네이버 부동산에 매물정보 홍보
                <br />
                - 상기 제공받은 개인정보를 활용하여, 네이버 회원정보에 저장된 개인정보(이름&amp;전화번호 또는 이름&amp; 네이버ID)와의 일치 여부 확인을 통한 본인확인 및 허위매물 등록 방지
                <br />- 휴대전화번호 또는 네이버 앱 푸시로 네이버 부동산 서비스에 등록 요청한 매물 관련 안내 문자 발송 및 매물 관리 기능 제공
              </td>
              <td>
                - 소유자명, 소재지, 가격, 소유자 전화번호, 네이버ID
                <br />
                - 위임장에 의한 처리일 경우 : 위임자 정보(이름, 주민등록번호 앞7자리, 주소, 위임받는 자와의 관계, 인감), 위임받는자 정보(이름, 주민등록번호 앞7자리, 주소)
                <br />
                - 분양계약서에 의한 처리일 경우 : 이름, 주소, 인감
                <br />
                - 명함에 의한 처리일 경우 : 이름, 소속회사, 직함, 전화번호, 이메일
                <br />
                - 재직증명서에 의한 처리일 경우 : 이름, 소속회사, 직함, 재직여부
                <br />
                - 여권/외국인등록증 등에 의한 처리일 경우 : 이름, 국적
                <br />- 전세계약서/전입신고확인서 등에 의한 처리일 경우 : 이름, 주소
              </td>
              <td>제공받은 개인정보를 60일간 보관</td>
            </tr>
            <tr>
              <td>
                [전화확인]
                <br />
                - 네이버 부동산에 매물정보 홍보, 허위매물 등록 방지
                <br />- 소유자 또는 의뢰인 연락처를 통해 네이버 매물검증 단계에서 유선으로 진성 매물 여부를 확인하기 위함
              </td>
              <td>소유자(의뢰인)명, 소유자(의뢰인) 연락처, 소재지, 거래유형, 가격</td>
              <td>제공받은 개인정보를 60일간 보관하며 소유자(의뢰인)명, 소유자(의뢰인) 연락처는 안전 한 부동산 거래 및 허위 매물 방지를 위하여 1년간 보관</td>
            </tr>
            <tr>
              <td>
                [현장확인1, 현장확인2]
                <br />
                - 네이버 부동산에 매물정보 홍보, 허위매물 등록 방지
                <br />- 실제 부동산 소유자의 동의를 거쳐 현장 방문을 통해 진성 매물 여부를 확인하기 위함
              </td>
              <td>소유자명, 소유자와의 관계, 소재지, 거래유형, 가격</td>
              <td>제공받은 개인정보를 60일간 보관하며 등기부등본은 안전한 부동산 거래 및 허위 매물 방지를 위하여 1년간 보관</td>
            </tr>
            <tr>
              <td>
                [모바일V1]
                <br />
                - 휴대전화번호로 매물 정보 확인 요청 페이지 접속 문자 발송
                <br />
                - 성명, 휴대전화번호를 이용하여 네이버 회원일 경우, 네이버 회원정보에 저장된 개인정보와의 일치 여부 확인 후 매물 정보 확인 페이지 접속 허용
                <br />
                - 매물 정보 확인 페이지에서 선택한 결과를 진성 매물 확인을 위한 기준으로 이용
                <br />- 네이버 부동산 서비스에 매물 등록 완료 후, 휴대전화번호로 안내 문자 발송
              </td>
              <td>
                - 공통 : 소재지, 거래유형, 가격
                <br />
                - 개인명의 : 소유자명, 소유자 휴대폰번호, 등기부등본(소유자명, 생년월일, 주소 / 등기부등본 첨부 시)
                <br />
                - 분양권 : 분양계약서(매수인명, 생년월일, 주소), 매수인 휴대폰번호
                <br />- 법인명의 : 의뢰인명(법인명의), 의뢰인 휴대폰번호(법인명의), 소유자와의 관계(법인명의), 등기부등본(소유자명, 생년월일, 주소 / 등기부등본 첨부 시)
              </td>
              <td>제공받은 개인정보를 60일간 보관하며 등기부등본은 안전한 부동산 거래 및 허위 매물 방지를 위하여 1년간 보관</td>
            </tr>
            <tr>
              <td>
                [모바일V2]
                <br />
                - 네이버 부동산에 매물정보 홍보
                <br />
                - 소유자명, 휴대전화번호, 생년월일을 이용하여 소유자가 네이버 회원일 경우, 네이버 회원정보에 저장 된 개인정보와의 일치 여부 확인을 통해 본인확인 및 허위 매물 등록 방지
                <br />
                - 네이버 회원이 아니거나 본인확인 미완료 회원일 경우, 통한 ARS 본인확인을 진행하며, 이 과정에서 소유자에게 본인확인을 위한 안내문자 및 ARS 발송
                <br />- 네이버 부동산 서비스에 매물 등록 완료 후, 휴대전화번호로 안내 문자 발송
              </td>
              <td>성별, 휴대전화번호, 가입한 이동통신사, 등기부등본(소유자명, 생년월일, 주소), 소재지, 거래유형, 가격</td>
              <td>제공받은 개인정보를 60일간 보관</td>
            </tr>
            <tr>
              <td>신한은행</td>
              <td>비대면 대출 서비스 제공</td>
              <td>이름, 휴대폰번호, 생년월일, 성별, 물건소재지, 거래금액, 계약일자, 거래일자(또는 계약기간)</td>
              <td>제공일로부터 금융(거래)종료 이후 5년까지 </td>
            </tr>
            <tr>
              <td>퍼스트어메리칸권원보험</td>
              <td>안심케어 서비스 제공</td>
              <td>이름, 휴대폰번호, 생년월일, 물건소재지, 매매금액, 계약일자, 잔금일자, 증권번호, 청약번호</td>
              <td>제공동의일로부터 당해 보험계약 효력 종료 후 5년까지 </td>
            </tr>
            <tr>
              <td>Park&Co(변호사 박진석 법률 사무소)</td>
              <td>안심케어 서비스 제공</td>
              <td>이름, 휴대폰번호, 생년월일, 물건소재지, 매매금액, 계약일자, 잔금일자, 증권번호, 청약번호</td>
              <td>상담 또는 정산 종료 후 6개월까지</td>
            </tr>
            <tr>
              <td>
                분양시행사,<br />
                분양시공사,<br />
                분양대행사,<br />
                광고대행사
              </td>
              <td>분양 및 이벤트 정보 전달, 마케팅 또는 광고</td>
              <td>이름, 연락처, 상호명, 주소</td>
              <td>분양 완료 시까지<br />(분양 완료 후 즉시 파기)</td>
            </tr>
            <tr>
              <td>이실장 안심케어 서비스 가입 중인 중개사 회원</td>
              <td>안심케어 서비스 관련 안내(안심케어 온라인 문의 신청 비회원 대상)</td>
              <td>거래 희망 지역, 이름, 휴대폰번호</td>
              <td>수집일로부터<br />3개월까지</td>
            </tr>
            <tr>
              <td>㈜아파트아이</td>
              <td>
                아파트아이 APP을 통한 중개사 정보 홍보 및 1:1 상담 의뢰 수신<br />
                (개인정보 제3자 제공에 동의한 멤버십 회원 또는 아파트아이 상품 가입 회원 대상)
              </td>
              <td>상호명, 대표자명, 대표번호, 휴대폰번호, 개설등록번호, 주소, 프로필 사진</td>
              <td>동의 철회 또는 멤버십 해지 시까지</td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>
  </ol>
  <p class="tit">
    <strong>6. 개인정보 처리의 위탁 </strong> <i class="terms-icon terms-icon06"></i>
  </p>
  <ol>
    <li>
      ① 회사는 더 나은 서비스를 제공하기 위하여 이용자의 개인정보 처리를 외부전문기관에 위탁할 수 있으며, 위탁하는 업무의 내용과 수탁자를 언제든지 쉽게 확인할 수 있도록 회사의 개인정보
      처리방침에 지속적으로 게재하여 공개합니다.
    </li>
    <li>② 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</li>
    <li>
      <ol>
        <li>
          <br />1) 위탁업체
          <div class="tableWrap">
            <table>
              <thead>
                <tr align="center">
                  <th>업체명</th>
                  <th>위탁업무 내용</th>
                  <th>보유 및 이용기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>SCI평가정보㈜</td>
                  <td>본인인증 서비스 제공</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>비즈톡㈜</td>
                  <td>SMS 및 카카오 알림톡 발송</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>다우기술</td>
                  <td>알뜰문자 서비스 이용</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>토스페이먼츠㈜</td>
                  <td>결제(PG) 서비스</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>나이스페이먼츠</td>
                  <td>페이앳 결제 서비스</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>잇팩</td>
                  <td>STT & TA 서비스 제공</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>AWS(서울)<br />(MSP : 메가존클라우드)</td>
                  <td>데이터 보관</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>(주)프로퍼티파트너스 <a href="/html/termsMarketer" class="co-blue">(영업컨설턴트 : 목록보기)</a>
                  </td>
                  <td>고객센터 업무 및 영업대행</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>브로드씨엔에스</td>
                  <td>CTI, 녹취시스템 유지보수</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>스팩스페이스</td>
                  <td>집찍고 서비스 제공, 고도화</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>커넥트파이클라우드</td>
                  <td>통합주택임대관리솔루션 eRoom의 개인정보 및 기타 관련 데이터 관리</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>어니스트에이아이</td>
                  <td>뉴렌트 서비스 제공, 보증금 조회 서비스 이용고객 분석</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>생활연구소</td>
                  <td>뉴렌트 서비스 웰컴키트 패키지 제작 및 배송</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>㈜오내피플</td>
                  <td>개인정보 수집 동의서 생성</td>
                  <td>수집/이용에 관한 동의일로부터 동의의 효력 기간까지</td>
                </tr>
                <tr>
                  <td>삼정데이타서비스㈜</td>
                  <td>메일 발송</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>㈜케이티알파</td>
                  <td>이벤트 경품(기프티콘) 발송 및 voc 처리</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>다홈즈</td>
                  <td>안심월세 뉴렌트 서비스<br />고객(임대인) 확보, 현장 지원</td>
                  <td>위탁계약 종료 시</td>
                </tr>
                <tr>
                  <td>㈜카카오</td>
                  <td>카카오톡채널을 이용한 정보성 메시지, 채팅 상담</td>
                  <td>위탁계약 종료 시</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          2) 재위탁업체
          <div class="tableWrap">
            <table>
              <thead>
                <tr align="center">
                  <th>수탁사</th>
                  <th>재수탁사</th>
                  <th>재위탁업무 내용</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="4">㈜케이티알파</td>
                  <td>㈜케이티</td>
                  <td>모바일쿠폰 문자 발송</td>
                </tr>
                <tr>
                  <td>㈜케이티아이에스</td>
                  <td>모바일쿠폰 관련 문의 처리</td>
                </tr>
                <tr>
                  <td>㈜케이티디에스</td>
                  <td>모바일쿠폰 발송 시스템 유지보수</td>
                </tr>
                <tr>
                  <td>㈜엠앤와이즈</td>
                  <td>모바일쿠폰 알림톡 발송</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
      </ol>
    </li>
    <li>
      ③ 회사는 위탁계약 체결 시 위탁업무 수행목적 외 개인정보 처리금지, 기술적∙관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리∙감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에
      명시하고, 수탁자가 개인정보를 안전하게 처리하는 지를 감독하고 있습니다.
    </li>
    <li>④ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</li>
  </ol>
  <p class="tit">
    <strong>7. 개인정보의 안전성 확보조치 </strong> <i class="terms-icon terms-icon10"></i>
  </p>
  <ol>
    <li>① 회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</li>
    <li>
      <ol>
        <li>
          1) 관리적 조치
          <p class="text">
            <b class="dot">·</b> 개인정보 내부관리계획의 수립 및 시행
          </p>
          <p class="text">
            <b class="dot">·</b> 개인정보취급자 지정 최소화 및 교육
          </p>
          <p class="text">
            <b class="dot">·</b> 입∙퇴사자 관리
          </p>
        </li>
        <li>
          2) 기술적 보호조치
          <p class="text">
            <b class="dot">·</b> 개인정보 접근 제한
          </p>
          <p class="text">
            <b class="dot">·</b> 비밀번호 등의 암호화
          </p>
          <p class="text">
            <b class="dot">·</b> 접속기록 보관 및 위∙변조 방지
          </p>
          <p class="text">
            <b class="dot">·</b> 해킹 등에 대비한 대책
          </p>
          <p class="text">
            <b class="dot">·</b> 보안프로그램 설치
          </p>
        </li>
        <li>
          3) 물리적 조치
          <p class="text">
            <b class="dot">·</b> 사무실 및 서버실 접근통제
          </p>
        </li>
      </ol>
    </li>
  </ol>
  <p class="tit">
    <strong>8. 개인정보 자동 수집 장치의 사용 및 거부에 관한 사항 </strong> <i class="terms-icon terms-icon04"></i>
  </p>
  <ol>
    <li>① 회사는 고객의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)'를 운용합니다.</li>
    <li>
      <ol>
        <li>
          1) 쿠키의 정의 및 저장 방법: 쿠키(Cookie)는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의 하드디스크에
          저장되기도 합니다.
        </li>
        <li>
          2) 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.
        </li>
        <li>
          3) 거부 설정 방법 : 다음의 방법을 통한 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다.
          <p class="text">
            <b class="dot">·</b> Internet Explorer의 경우: 웹 브라우저 상단의 도구 메뉴 &gt; 인터넷 옵션 &gt; 개인정보 &gt; 고급
          </p>
          <p class="text">
            <b class="dot">·</b> Edge 의 경우: 웹 브라우저 우측 상단의 설정 메뉴 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리 및 삭제
          </p>
          <p class="text">
            <b class="dot">·</b> Chrome의 경우: 웹 브라우저 상단의 맟춤설정 및 제어 &gt; 설정 &gt; 개인정보 및 보안 &gt; 쿠키 및 기타 사이트 데이터
          </p>
        </li>
        <li>4) 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.</li>
      </ol>
    </li>
  </ol>
  <p class="tit">
    <strong>9. 개인정보 보호책임자 및 담당자</strong> <i class="terms-icon terms-icon12"></i><i class="terms-icon terms-icon11"></i>
  </p>
  <ol>
    <li>
      ① 회사는 이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보 보호책임자를 지정하고 있습니다. 개인정보와 관련된 문의사항이 있으시면
      아래의 개인정보 보호책임자 및 담당자에게 연락주시기 바랍니다. 문의하신 사항에 대해서 신속하고 성실하게 답변해 드리겠습니다.
    </li>
    <li>
      <div class="tableWrap">
        <table>
          <colgroup>
            <col width="25%" />
            <col width="20%" />
            <col width="20%" />
            <col width="35%" />
          </colgroup>
          <tbody>
            <tr align="center">
              <th>구분</th>
              <th>직위</th>
              <th>성명</th>
              <th>전자우편</th>
            </tr>
            <tr>
              <td>개인정보 보호책임자</td>
              <td>PL</td>
              <td>한대규</td>
              <td>Privacy@proptier.co.kr</td>
            </tr>
          </tbody>
        </table>
      </div>
    </li>
    <li>② 이용자는 이실장 서비스(이실장, 이실장넷, 이실장플러스)를 이용하시면서 발생한 모든 고충(개인정보보호 관련 문의, 불만처리, 피해구제 등)에 관한 사항은 개인정보보호책임자 및 아래의 담당 부서에 문의할 수 있습니다. </li>
    <li>
      <div class="tableWrap">
          <colgroup>
              <col width="120px">
              <col>
          </colgroup>
          <table>
              <thead>
              <tr align="center">
                  <th colspan="2">개인정보 열람·정정·처리정지·삭제 청구 접수·처리 부서</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                  <td>접수 부서</td>
                  <td>고객센터</td>
              </tr>
              <tr>
                  <td>전자우편</td>
                  <td>help@proptier.co.kr</td>
              </tr>
              <tr>
                  <td>전화번호</td>
                  <td>1800-6950</td>
              </tr>
              </tbody>
          </table>
      </div>
      <p class="text">※ 고객센터 운영시간은 평일 오전 9시부터 오후 6시(09:00~18:00)까지 운영되고 있으며 토요일, 공휴일은 운영하지 않습니다.</p>
  </li>
  </ol>
  <p class="tit">
    <strong>10. 권익침해 구제방법</strong> <i class="terms-icon terms-icon13"></i>
  </p>
  <ol>
    <li>① 이용자는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.</li>
    <li>
      ▶ 개인정보 침해신고센터
      <ol>
        <li>
          <p class="text">
            <b class="dot">·</b> 홈페이지:
            <a href="https://privacy.kisa.or.kr/" target="_blank" class="co-blue">
              privacy.kisa.or.kr
            </a>
          </p>
          <p class="text">
            <b class="dot">·</b> 전화: (국번없이) 118
          </p>
        </li>
      </ol>
    </li>
    <li>
      ▶ 개인정보 분쟁조정위원회
      <ol>
        <li>
          <p class="text">
            <b class="dot">·</b> 홈페이지:
            <a href="https://www.kopico.go.kr/" target="_blank" class="co-blue">
              www.kopico.go.kr
            </a>
          </p>
          <p class="text">
            <b class="dot">·</b> 전화: (국번없이) 1833-6972
          </p>
        </li>
      </ol>
    </li>
    <li>
      ▶ 대검찰청
      <ol>
        <li>
          <p class="text">
            <b class="dot">·</b> 홈페이지:
            <a href="https://www.spo.go.kr" target="_blank" class="co-blue">
              www.spo.go.kr
            </a>
          </p>
          <p class="text">
            <b class="dot">·</b> 전화: (국번없이) 1301
          </p>
        </li>
      </ol>
    </li>
    <li>
      ▶ 경찰청
      <ol>
        <li>
          <p class="text">
            <b class="dot">·</b> 홈페이지:
            <a href="https://ecrm.police.go.kr" target="_blank" class="co-blue">
              ecrm.police.go.kr
            </a>
          </p>
          <p class="text">
            <b class="dot">·</b> 전화: (국번없이) 182
          </p>
        </li>
      </ol>
    </li>
  </ol>
  <p class="tit">
    <strong>11. 기타</strong>
  </p>
  <ol>
    <li>① 회사의 인터넷 서비스에 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에 대해서는 본 “개인정보 처리방침”이 적용되지 않음을 알려 드립니다.</li>
  </ol>
  <p class="tit">
    <strong>12. 개인정보 처리방침 변경에 관한 사항 </strong> <i class="terms-icon terms-icon09"></i>
  </p>
  <ol>
    <li>
      <p class="text">
        <b class="dot">·</b> 공지일자: 2025년 03월 11일
      </p>
    </li>
    <li>
      <p class="text">
        <b class="dot">·</b> 시행일자: 2025년 03월 11일
      </p>
    </li>
  </ol>
</div>
`,
};

export const TERMS_INFO = {
  title: '프롭티어 통합회원 이용약관',
  content: `
  <div class="personalInfoWrap terms">
  <p class="text"><strong>본 약관은 2024년 11월 05일부터 적용됩니다.</strong></p>
  <strong>제 1 조 (목적)</strong>
  <p class="text">
    본 약관은 프롭티어㈜(이하 "회사"”)가 운영하는 모든 유, 무료서비스 이용과 관련하여, 구현되는 단말기(PC, TV, IP-TV, 휴대형 단말기 등의 각종 유무선 장치를 포함)를 불문하고, 필요한 회사와
    회원의 권리, 의무 및 책임사항, 이용조건 및 절차, 기타 제반사항을 규정함을 목적으로 합니다.
  </p>
  <strong>제 2조 (정의)</strong>
  <p class="text">이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
  <ol>
    <li>
      1. 서비스(또는 ”프롭티어 서비스”) : 회사가 회원에게 사이트를 기반으로 다양한 정보, 자료 등으로 제작, 게시된 각종 콘텐츠를 유·무상으로 이용할 수 있도록 제공하거나 그 제공을 매개하는
      행위 일체를 말합니다.
    </li>
    <li>
      2. 사이트 : 회사가 서비스를 회원에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 설정한 가상의 영업장 또는 회사가 운영하는 웹사이트, 모바일웹, 앱 등의 서비스를 통칭하며, 회사에서
      서비스를 제공받을 수 있는 아래의 사이트를 말합니다.
      <br />* 프롭티어 통합사이트 : 이실장, 이실장넷, 이실장플러스(이실장) 
    </li>
    <li>3. 이용자 : 프롭티어 통합사이트에 접속하여 본 약관에 따라 회사가 제공하는 서비스를 받는 통합회원 및 비회원을 말합니다.</li>
    <li>
      4. 통합회원 : 본 약관에 동의 후 필요한 개인(일반) 및 중개업 정보를 제공한 중개법인, 중개사무소 등의 중개업자를 의미하며, 프롭티어 통합사이트의 정보 및 서비스를 이용할 수 있는 자를
      의미합니다.
    </li>
    <li>5. 비회원 : 회원가입 또는 로그인 없이 서비스를 사용하는 이용자로서 회사가 제공하는 서비스 이용에 일부 제한이 있는 이용자를 말합니다.</li>
    <li>
      6. 모임 : 회사의 서비스를 통해 회원이 직접 만든 온라인상의 가상공간을 의미합니다. 회원이 한 명 이상의 다른 회원과 소통하거나 교신할 수 있도록 회사가 제공하는 서비스를 의미합니다.
    </li>
    <li>7. 모임장 : 모임을 개설하였거나, 모임의 개설을 위임받은 회원을 의미합니다.</li>
    <li>8. 매물정보 : 부동산 거래 정보 및 거래 대상 물건에 수반되는 다양한 부가 정보를 의미합니다.</li>
    <li>
      9. 제휴사 : 회사와 제휴한 업체를 말하며, 부동산 정보 서비스 또는 부동산 컨설팅 서비스를 제공할 수 있습니다. "제휴사 사이트"라 함은 "제휴사"가 서비스를 제공하고 있으며 제휴 대상이 되는
      웹사이트, 모바일웹, 앱 등의 서비스를 통칭합니다. 제휴사는 CP사가 포함됩니다.
    </li>
    <li>
      10. 게시판 : 명칭, 형태, 위치와 상관없이 회원에게 공개할 목적으로 부호∙문자∙음성∙음향∙화상∙동영상 등의 정보(이하“게시물”이라 한다.)를 회원 또는 회사가 게재할 수 있도록 회사가 제공하는
      서비스 상의 가상공간을 말합니다
    </li>
    <li>
      11. 회원 아이디 : 회원의 식별 및 서비스 이용을 위하여 회원의 신청에 따라 수급받은 문자 또는 회원의 휴대폰 번호를 뜻합니다. 가입자의 점유인증이 확인되어야 하고, 중복은 허용하지
      않습니다.
    </li>
    <li>
      12. 비밀번호 : 아이디로 식별되는 회원의 본인여부를 검증하기 위하여 회원이 설정하여 회사에 등록한 고유의 문자와 숫자 조합을 말합니다. 회원은 아이디와 함께 비밀번호를 가집니다. 또한
      회원은 아이디 및 비밀번호를 사용하여 프롭티어 통합사이트에 접속이 가능합니다.
    </li>
    <li>13. 멤버십 : 회원이 서비스를 이용하기 위하여 입력 · 등록한 결제수단 또는 결제정보로 6개월 또는 일정시기에 결제하는 서비스를 의미합니다.</li>
    <li>14. 부동산정보 : 프롭티어 서비스에서 이용할 수 있는 부동산매물/시세/분양/제휴사 콘텐츠/공공데이터 정보 등을 말합니다.</li>
    <li>15. AI추천 : “회사”가 자체적으로 제작한 AI알고리즘을 통해 매물을 추천해주는 것을 말합니다.</li>
    <li>16. 분양정보 : “회사”가 “통합회원”에게 제공하는 공동주택(아파트, 오피스텔, 도시형생활주택 등)의 분양에 관련된 모든 글, 사진, 동영상 등의 정보를 말합니다.</li>
    <li>17. 부동산 리포트: 회사가 부동산 정보를 분석해 이용자에게 제공하는 주요 서비스 콘텐츠입니다.</li>
    <li>18. AVM 가격 : 회사가 자체적으로 분석한 AI 알고리즘을 통해 계산된 가격을 말합니다.</li>
  </ol>
  <strong>제 3조 (약관의 게시와 개정)</strong>
  <p class="text">이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
  <ol>
    <li>
      1. 회사는 이 약관의 내용과 주소지, 관리자의 성명, 개인정보보호 담당자의 성명, 연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가 알 수 있도록 회사가 관리하는 사이트의 웹/앱 서비스
      메인화면(전면)에 게시합니다.
    </li>
    <li>
      2. 회사는 "약관의 규제에 관한 법률", "전자문서 및 전자거래 기본법", "전자서명법", "정보통신망 이용촉진 및 정보보호 등에 관한 법률 (이하 "정보통신망법")" 등 관련법을 위배하지 않는
      범위에서 이 약관을 개정할 수 있습니다.
    </li>
    <li>
      3. 회사가 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 제 1항의 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 이
      약관의 중대한 변경이거나 회원에게 불리한 변경인 경우에는 적용일자 30일 이전까지 이를 공지하고 제 22조 또는 제24조에서 정한 방법으로 회원에게 통지하도록 합니다.
    </li>
    <li>
      4. 회사가 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 30일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 따로 고지하였음에도 회원이 명시적으로
      거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.
    </li>
    <li>
      5. 회원이 변경된 약관에 동의하지 않는 경우, 해당 회원에 대해서는 종전 약관이 그대로 적용됩니다. 다만, 종전 약관을 그대로 적용할 수 없는 불가피한 사정이 있는 경우 회사는 회원에 대해
      상당한 기간을 정하여 탈퇴(해지)를 요청할 수 있고, 이 경우 회사는 회원에 대해 정당한 보상을 실시합니다.
    </li>
    <li>6. 본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법, 정보통신망법 및 기타 관련 법령의 규정에 의합니다.</li>
  </ol>
  <strong>제 4조 (운영정책)</strong>
  <p class="text">
    회사는 본 약관 외에도 서비스의 운영과 관련된 상세한 사항을 운영정책으로 별도 수립하여 적용할 수 있으며, 이 경우 회사는 운영정책의 내용 및 변경사항을 프롭티어가 서비스하는 공지사항
    게시판에 사전 공지합니다.
  </p>
  <strong>제 5조 (약관의 해석)</strong>
  <p class="text">이 약관에서 정하지 아니한 사항이나 해석에 대해서는 관계법령 또는 상관례에 따릅니다.</p>
  <strong>제 6조 (회원 가입)</strong>
  <ol>
    <li>
      1. 회원으로 가입하여 프롭티어 서비스의 회원이 되고자 하는 “개인(일반) 및 중개법인, 중개사무소 등의 중개업자(이하 “가입신청자”)는 본 약관에 동의 후 회사가 정한 회원가입 신청양식에 따라
      개인정보입력 및 중개업정보를 기입하여 회원가입을 신청합니다.
    </li>
    <li>
      2. 회사는 가입신청자 중 중개법인, 중개사무소를 영위하는 사업자 회원에 대하여 하기의 증빙서류를 각 목적에 따라 요구하며, (이실장) 서비스의 경우 사업자 회원은 해당 증빙서류를 필수로
      제출하여야 합니다.
      <ol>
        <li>① 개설등록증 : 개업 공인중개사 여부 확인 목적</li>
        <li>② 사업자등록증 : 개업 공인중개사 여부 및 정상 사업자 확인 목적</li>
      </ol>
    </li>
    <li>3. 사업자 회원가입시 가입신청자는 반드시 정확한 개인정보 및 사업자정보, 사업주정보를 회사에 제공하여야 하고, 회사는 해당 정보의 진위여부 확인 절차를 거칩니다.</li>
    <li>
      4. 회사는 가입신청자가 다음 각 호에 해당하지 않는 경우 프롭티어 통합 회원가입을 승인합니다.
      <ol>
        <li>① 가입신청자의 등록 및 신청 내용에 허위, 누락, 오기가 있는 경우</li>
        <li>② 실명이 아니거나 타인의 명의를 도용한 경우</li>
        <li>③ 회사가 제시하는 내용을 미기입 한 경우</li>
        <li>④ 사업자회원의 경우 관련 법령에 따라 유효하게 등록 및 확인된 중개업자가 아닌 경우</li>
        <li>⑤ 휴∙폐업 등의 사유로 정상사업자가 아니거나, 타 사업자 명의를 이용한 경우</li>
        <li>⑥ 만 14세 미만 미성년자인 경우</li>
        <li>⑦ 가입신청자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
        <li>⑧ 기타 이 약관에 위배되거나 위법 또는 부당한 가입신청임이 확인된 경우</li>
      </ol>
    </li>
    <li>5. 회사는 서비스와 관련하여 기술상 또는 업무상 문제가 있는 경우에는 문제가 해결될 때까지 회원가입 신청의 승낙을 유보할 수 있습니다.</li>
    <li>6. 본 조 제 4항과 제 5항에 따라 회원가입 신청의 승낙을 하지 아니하거나 유보한 경우, 회사는 원칙적으로 이를 가입신청자에게 알리도록 합니다.</li>
    <li>7. 이용계약의 성립 시기는 회사가 신청절차 상에서 가입신청자에게 승낙을 표시한 시점으로 합니다.</li>
  </ol>
  <strong>제 7조 (개인정보보호 의무)</strong>
  <ol>
    <li>
      1. 회사는 개인정보 보호법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보 처리방침이
      적용됩니다. 다만 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보 처리방침이 적용되지 않습니다.
    </li>
    <li>
      2. 회사는 서비스 제공과 관련해서 수집된 회원의 신상정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않습니다. 다만, 관련 법률의 규정에 의해 국가기관의 요구가 있는 경우, 범죄에 대한
      수사상의 목적이 있거나 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우, 귀하가 당 사이트에 제공한 개인정보를 스스로 공개한 경우로 회사가 이를 제3자에게 누설, 배포한 것이 아닌
      경우에는 그러하지 않습니다.
    </li>
    <li>
      3. 회원의 개인정보는 오직 회원만이 열람/수정/삭제할 수 있으며, 이는 전적으로 회원의 ID와 비밀번호에 의해 관리되고 있습니다. 따라서 타인에게 본인의 ID와 비밀번호를 알려주어서는 안 되며,
      서비스 종료 시에는 반드시 로그아웃 하고, 웹 브라우저의 창을 닫는 등 필요한 조치를 취하여야 합니다.(이는 타인과 컴퓨터를 공유하는 인터넷 카페나 도서관 같은 공공장소에서 컴퓨터를
      사용하는 경우에 회원의 정보보호를 위하여 필요한 사항입니다.)
    </li>
  </ol>
  <strong>제 8조 (회원의 아이디 및 비밀번호에 대한 관리 의무)</strong>
  <ol>
    <li>1. 아이디 및 비밀번호에 대한 관리책임은 회사의 귀책사유가 없는 이상 회원에게 있습니다.</li>
    <li>2. 회원은 자신의 아이디 및 비밀번호를 제3자가 이용하게 해서는 안 됩니다.</li>
    <li>3. 회원 아이디와 비밀번호가 도용되거나 제 3자가 사용하고 있음을 인지한 회원은 바로 회사에 알리고 회사의 안내에 따라야 합니다.</li>
    <li>
      4. 제3항의 경우에 회원이 회사에 사실을 통지하지 않거나 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대해서는, 회사의 고의 또는 과실이 없는 한, 회사가 책임지지 않습니다.
    </li>
    <li>5. 회원 아이디로 사용되는 휴대폰번호가 변경·생성될 경우 지체없이 수정하여야 합니다.</li>
  </ol>
  <strong>제 9조 (회사의 의무)</strong>
  <ol>
    <li>1. 회사는 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 본 약관이 정하는 바에 따라 회원에게 안정적인 프롭티어 서비스를 제공하기 위해 최선을 다합니다.</li>
    <li>2. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의 개인정보보호를 위한 보안시스템을 구축하며 개인정보 보호정책을 공시하고 준수합니다.</li>
    <li>
      3. 회사는 회원 상호간의 거래에 있어서 어떠한 보증도 제공하지 않습니다. 다만 회원 상호간의 거래에 있어 회사의 귀책사유로 인하여 회원에 손해가 발생한 경우에는 그에 대한 책임을
      부담합니다.
    </li>
    <li>4. 회사는 이용계약의 체결, 계약사항의 변경 및 해지 등 회원과의 계약관계절차 및 내용 등에 있어 회원에게 편의를 제공하도록 노력합니다.</li>
    <li>
      5. 회사는 회원이 제기하는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를 거쳐 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우는 회원에게 그 사유와 처리
      일정을 통보하여야 합니다.
    </li>
  </ol>
  <strong>제 10조 (회원의 의무)</strong>
  <ol>
    <li>
      1. 회원은 다음 각 호의 행위를 하여서는 안 됩니다. 만약 다음 각호와 같은 행위가 확인되면 회사는 해당 회원에게 서비스 이용에 대한 제재를 가할 수 있으며 민형사상의 책임을 물을 수
      있습니다.
      <ol>
        <li>① 회사의 서비스 운영을 고의 또는 과실로 방해하는 행위</li>
        <li>② 회사의 임직원, 피용자, 상담원, 업무수탁자(이하‘임직원등’)에게 폭력적, 명예훼손적, 모욕적, 또는 성적 굴욕감이나 혐오감을 유발할 수 있는 발언이나 행동을 하는 행위</li>
        <li>③ 통념상 비합리적인 요구 또는 요청을 임직원등에게 지속적으로 또는 반복적으로 하는 행위</li>
        <li>④ 임직원등에게 서비스 이용과 무관한 연락을 하는 행위</li>
        <li>
          ⑤ 그 밖에 위 각 호의 행위에 준하는 일체의 업무 방해 행위
          <p>⑴ 신청 또는 변경 시 허위내용의 등록</p>
          <p>⑵ 타인의 정보 도용</p>
          <p>⑶ 허위 매물 정보의 등록</p>
          <p>⑷ 의뢰인(소유주 또는 세입자로 회원에게 해당 매물에 대한 중개를 의뢰한 자)으로부터 개인정보 수집 이용 및 제3자 제공 등에 대해 동의를 얻지 않은 매물 정보의 등록</p>
          <p>⑸ 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</p>
          <p>⑹ 회사 및 기타 제3자의 저작권 등 지적재산권에 대한 침해</p>
          <p>⑺ 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</p>
          <p>⑻ 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스 또는 부동산정보서비스 화면에 공개 또는 게시하는 행위</p>
          <p>⑼ 사기 및 악성 글 등록 등 건전한 거래 문화 활성에 방해되는 행동</p>
          <p>⑽ 이용자가 서비스 이용을 위해 제공한 모든 종류의 개인정보를 이용자의 이용 목적 외에 이용하거나 제3자에게 제공하는 행위</p>
          <p>
            ⑾ 회사의 사전 허락 없이 자동화된 수단(예: 매크로 프로그램, 로봇(봇), 스파이더, 스크래퍼 등)을 이용하여 서비스 회원으로 가입을 시도 또는 가입하거나, 서비스에 로그인을 시도 또는
            로그인하거나, 각 “사이트”에 게시물을 게재하거나, 서비스에 게재된 다른 회원의 아이디(ID), 게시물 등을 수집하거나, 서비스의 제공 취지에 부합하지 않는 방식으로 서비스를 이용하는
            어뷰징(남용) 행위를 막기 위한 “회사”의 기술적 조치를 무력화하는 일체의 행위(예: IP를 지속적으로 바꿔가며 접속하는 행위, Captcha를 외부 솔루션 등을 통해 우회하거나 무력화하는 행위
            등
          </p>
          <p>⑿ 기타 위 각 호에 준하는 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정되는 행위</p>
        </li>
      </ol>
    </li>
    <li>
      2. 회사는 전항에 규정된 위반 행위를 하는 회원에 대해 사전 통지 후 서비스 일시 중단 등의 조치를 취할 수 있으며 필요한 경우 이에 대한 위반행위에 관한 시정을 요구할 수 있습니다(다만,
      긴급히 조치할 필요가 있는 경우에는 사후에 통지할 수 있습니다). 특히 회원이 시정을 요구받은 기간 내에 시정하지 아니한 경우, 동일한 위반 행위를 반복할 경우 또는 다수의 위반 행위가 확인된
      경우, 회사는 회원과의 서비스 이용계약을 해지할 수 있습니다. 단 이 경우 회사는 사전에 회원에게 공문, 전화, 이메일, SMS 등의 방법으로 개별 통지합니다.
    </li>
    <li>3. 회원은 관련 법령, 회사의 모든 약관 또는 정책 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.</li>
    <li>
      4. 회원은 회원가입 신청시 기재한 사항이 변경되었을 경우, 회원 본인이 변경 가능한 정보는 즉시 변경을 진행하고, 이 외의 정보는 즉시 회사에 변경요청을 해야 하며, 정확한 사업주 정보 및
      관련 증빙자료를 회사에 제공해야 됩니다. 회사의 고의 또는 과실이 인정되지 않는 이상, 회사에 변경사항을 알리지 않아서 발생한 불이익에 대하여 회사는 책임지지 않습니다.
    </li>
    <li>5. 회원은 프롭티어 통합사이트에 접속하여 언제든지 본인의 개인정보 또는 회원정보를 열람할 수 있습니다.</li>
    <li>6. 사업자회원 대표의 경우 사업장의 멤버로 속한 소속공인중개사, 중개보조원, 파트타이머(이하 "멤버")에 대한 회원정보를 열람할 수 있으며, 멤버의 초대, 탈퇴, 관리가 가능합니다.</li>
  </ol>
  <strong>제 11조 (모임의 의무)</strong>
  <ol>
    <li>
      1. 모임은 모든 회원이 개설할 수 있으며 다음에 해당하는 모임은 개설이 불가합니다.
      <ol>
        <li>① 사회질서 및 미풍양속을 저해하는 모임</li>
        <li>② 사기, 기만, 불법거래 등 현행법 및 법률 위반 거래 목적의 모임</li>
        <li>③ 용도 외 개인의 이익과 관련된 영업 목적의 모임</li>
        <li>④ 외설, 폭력, 불건전 교제 조장 등 기타 공서양속에 반하는 내용의 모임</li>
        <li>⑤ 회사 및 제3자에 대한 비방, 명예 훼손, 개인정보 침해 등 기타 피해를 줄 수 있는 모임</li>
        <li>⑥ 기타 본 항에 준하거나 회사의 판단으로 운영정책에 위배되거나 서비스에 위협이 되는 내용</li>
      </ol>
    </li>
    <li>
      2. 모임은 이용안내 및 운영수칙을 준수하여야 하며 이를 위반한 경우 회사는 임의로 모임을 폐쇄 및 제한할 수 있습니다.
      <ol>
        <li>① 모임장은 공동모임장을 선택할 수 있으며 관리권한 역시 부여 가능합니다.</li>
        <li>② 모임장과 공동모임장은 어떠한 경우에도 회원 동의 없이 개인의 신상정보를 타인에게 제공하거나 공개할 수 없으며 위반 시 문제의 책임은 모임장과 공동모임장에게 있습니다.</li>
        <li>
          ③ 모임장과 공동모임장은 모임 관리의 의무가 있고 자체적으로 공지를 통해 모임 운영방침을 정할 수 있으나 회사가 판단하기에 불합리하거나 전체 운영정책에 위반되는 경우 해당 모임을
          폐쇄하거나 활동에 제한을 가할 수 있습니다.
        </li>
        <li>④ 모임 내 온라인 및 오프라인에서 회원간 금전 거래가 발생할 경우 이로 인한 일체의 책임은 당사자들에게 있으며 발생한 손해는 회사가 책임지지 않습니다.</li>
        <li>⑤ 모임장과 공동모임장은 이용약관 및 운영정책에서 금지한 게시물에 대하여 모니터링을 해야하며, 위배되는 게시물을 발견하거나 신고를 받으면 해당 게시물을 즉시 삭제해야 합니다.</li>
        <li>⑤ 모임장과 공동모임장은 이용약관 및 운영정책에 어긋나는 회원을 모임에서 탈퇴시키거나 이용제한을 할 수 있습니다.</li>
        <li>⑦ 모임장은 회원이 있는 상태에서 모임 삭제가 불가하며 모임장 양도를 통해 모임을 양도 가능합니다.</li>
        <li>⑧ 모임장은 모임 탈퇴가 불가하며, 모임장 양도 후 탈퇴할 수 있습니다.</li>
        <li>
          ⑨ 일정기간동안 모임활동이 없는 경우 휴면모임으로 전환되며, 전환 1개월 전 모임장과 공동모임장에게 휴면모임 전환 알림을 발송합니다. (휴면모임 = 모임명이 검색되지 않으며 모임 활동에
          제한이 있을 수 있습니다. 휴면모임 해제 시 즉시 휴면 해제됨)
        </li>
        <li>⑩ 회사는 회사가 제공하는 서비스 안에서 모임장이 회원들을 모집 후 타 서비스로 단체 이동하는 것을 허용하지 않습니다.</li>
        <li>⑪ 기타 회사 서비스 운영에 피해가 발생할 수 있는 경우 회사는 모임 및 모임장에 대해 제재할 수 있습니다.</li>
      </ol>
    </li>
  </ol>
  <strong>제 12조 (게시물 서비스)</strong>
  <ol>
    <li>1. 회원이 작성한 게시판 게시물의 저작권은 해당 게시물의 저작자에게 귀속합니다.</li>
    <li>2. 회원이 작성한 게시판 게시물은 검색결과에 노출될 수 있으며 회원은 해당 게시물을 삭제할 수 있습니다.</li>
    <li>
      3. 회사는 모든 게시물을 저장 및 보관할 수 있으며 법령, 운영정책에 위반되는 사실이 확인된 경우 분쟁조정, 민원처리, 서비스 질서유지를 위해 열람이 가능하며 법령에서 정한 경우 외에는 제
      3자에게 제공하지 않습니다.
    </li>
    <li>
      4. “정보통신망이용촉진및보호에관한법률” 및 “저작권법” 등 관련 법령에 위반되는 내용을 포함한 경우 회사는 게시물에 대해 게시중단 및 삭제 등 요청할 수 있으며 관련 법령에 따라 조치를
      취합니다.
    </li>
    <li>5. 서비스에 등록된 게시물은 모니터링 될 수 있으며 약관의 규정 및 운영정책에 위배되는 경우 관련 법령에 따라 게시물을 임의로 삭제할 수 있습니다.</li>
    <li>6. 회원이 탈퇴를 한 경우 해당 모임에 등록된 게시물은 수정 및 삭제가 되지 않으며 이로 인하여 발생한 피해에 대해서 회사는 책임지지 않습니다.</li>
    <li>7. 회원이 탈퇴를 한 경우 본인 계정에 등록된 게시물은 임의로 삭제될 수 있습니다.</li>
    <li>8. 기타 게시물에 대한 게시중단은 고객센터 온라인문의를 통해 접수를 받고 있습니다.</li>
  </ol>
  <strong>제 13조 (위치 기반 서비스 제공)</strong>
  <ol>
    <li>1. 회사는 이용자에게 유용한 서비스를 제공하기 위하여 서비스에 위치기반서비스를 포함시킬 수 있습니다.</li>
    <li>2. 회사의 위치기반서비스는 이용자의 단말기기의 위치정보를 수집하는 위치정보 사업자로부터 위치정보를 전달 받아 이용자에게 제공하는 서비스입니다.</li>
    <li>3. 위치기반 서비스는 이용자의 현재 위치 또는 특정 위치에 대한 정보를 활용하여 생성한 정보를 제공하거나 이용자 위치기반 광고 정보 제공 목적으로 사용됩니다.</li>
    <li>4. 회사는 위치정보의 보호 및 이용 등에 관한 법률에 따라 개인위치정보 및 위치정보 이용ㆍ제공사실 확인 데이터를 6개월 이상 보관합니다.</li>
    <li>5. 이용자의 무선서비스 이용 시 발생하는 데이터 통신료는 별도이며, 이용자께서 가입한 각 이동통신사의 정책에 따릅니다.</li>
    <li>
      6. 본 조에서 정한 사항 및 그 밖에 기타 자세한 사항은
      <a href="https://cord-dragonfly-63e.notion.site/24-01-05-d48f902cab1f4773ab9f32b523d2d69d" target="_blank" class="co-blue">
        위치기반 서비스 이용약관
      </a>
      을 참고해 주시기 바랍니다.
    </li>
  </ol>
  <strong>제 14조 (매물정보 서비스의 제공)</strong>
  <p class="text">회사가 서비스를 통해 제공하는 서비스는 아래 각 호와 같습니다.</p>
  <ol>
    <li>1. 회원은 프롭티어 서비스에 접속하여 매물정보를 등록∙관리∙삭제할 수 있습니다. 또한 회사는 업무에 필요한 각종 서비스와 부동산관련 정보를 제공합니다.</li>
    <li>
      2. 회사는 회원이 등록한 매물정보를 “사단법인 한국인터넷자율정책기구 산하 부동산매물검증센터”(이하 “매물검증센터”라 칭한다.)에 매물 검증을 의뢰할 수 있으며, 매물검증과정에서 검증실패
      처리된 매물정보에 대하여 회원에게 매물정보 수정을 요청하거나 매물정보 노출을 거부할 수 있습니다.
    </li>
    <li>
      3. 각 제휴사(CP)에 노출되는 매물정보에 대한 노출정책(순서, 기간, 영역 등)의 지정, 변경, 추가 등에 대해서는 회사가 일체의 권한을 가집니다. 다만, 회사는 정책 변경 시 기존 회원의 권리를
      부당하게 제한하지 않도록 최대한 노력하고, 필요한 경우 정당한 보상을 실시합니다.
    </li>
    <li>
      4. 회사는 회원 별로 제휴사에 대한 매물정보 제공 동의를 득한 후 해당 매물정보를 제휴사에 제공할 수 있으며, 제휴사에 제공된 매물정보는 제휴사의 매물 노출정책에 따라 제휴사이트에
      노출됩니다.
    </li>
    <li>
      5. 회사는 “사단법인 한국인터넷자율정책기구 산하 매물클린센터”(이하 “매물클린센터”라 칭한다)로부터 허위매물로 확인된 매물정보에 대해서는 회원에게 상당한 기간을 정하여 소명을 요구하고 위
      기간 내에 합리적 소명이 없는 경우 이실장플러스, 매경부동산사이트 및 “제휴사이트”에 노출 중인 해당 매물정보의 노출을 종료할 수 있습니다. 이 경우 회사가 별도로 정한 “허위매출처리규정”에
      따라 해당 회원의 회원 권한 및 매물관리센터의 일부 또는 전부 기능에 대한 사용상의 규제를 할 수 있습니다.
    </li>
    <li>
      6. 네이버부동산 매물 광고 서비스는 이실장에 입점한 네이버부동산 입점 정보업체 또는 서비스를 통해 제공되며, 회원은 하나 또는 복수 이상의 정보업체 또는 서비스를 선택하여 매물 광고를
      집행할 수 있습니다. 이 과정에서 회원정보, 매물정보, 상품정보 등이 회원이 선택한 정보업체 또는 서비스에 제공될 수 있습니다.
    </li>
    <li>7. 허위 매물정보를 제공함으로써 회사에게 손해가 발생한 경우 회원은 이에 대한 손해를 배상하여야 합니다.</li>
  </ol>
  <strong>제 15조 (유료서비스 및 결제)</strong>
  <ol>
    <li>1. 회원은 회사가 제공하는 회원 계정에 예치금(이하 “충전금”이라 한다)을 적립할 수 있으며, 환급도 가능합니다.</li>
    <li>2. 회원은 충전금으로 이용대금을 결제하고 유료서비스를 구매하여 이용할 수 있습니다.</li>
    <li>
      3. 회사는 회원 별로 충전금 결제 방식으로 구매 및 이용이 가능한 유료서비스의 종류 및 이용 한도를 제한할 수 있으며, 서비스 페이지 등을 통해 관련 사항을 안내할 수 있습니다. 매물 전송비용
      등 서비스 이용 가격은 프로모션 여부에 따라 수시로 변경될 수 있으며, 각 화면에서 결제하시기 전 확인하실 수 있습니다.
    </li>
    <li>4. 충전금은 회원이 요청한 경우 특정 금액 미만으로 될 경우, 사전에 선택한 결제수단으로 일정 금액을 자동충전 할 수 있으며, 이 경우 회사는 회원에게 고지합니다.</li>
    <li>5. 회원이 충전금 환급을 요청하는 경우, 회사는 충전한 결제수단을 취소하거나, 취소가 안 되는 경우 현금으로 환급해 줄 수 있습니다.</li>
    <li>6. 회사는 회원이 부정한 방법으로 충전금을 취득하거나 사용하였다고 판단한 경우 이를 회수하거나 사용 정지시킬 수 있습니다.</li>
  </ol>
  <strong>제 16조 (정보의 제공 및 광고의 게재)</strong>
  <ol>
    <li>1. 회사는 회원이 서비스 이용 시 필요하다고 인정되는 다양한 정보를 공지사항, 서비스화면, 전자우편 등의 방법으로 회원에게 제공할 수 있습니다.</li>
    <li>
      2. 회원은 관련 법령에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지 위 정보제공에 대하여 수신 거절을 할 수 있습니다. 단, 이미 발송된 광고성 정보에 대해서는
      적용하지 않습니다.
    </li>
    <li>3. 회사가 제공하는 서비스 및 부동산정보서비스의 운영과 관련하여 회사가 제공하는 서비스의 화면 및 홈페이지 등에 광고를 게재할 수 있습니다.</li>
    <li>4. 회원은 회사에서 제공하는 홈페이지 배너 광고에 대한 임의 삭제, 비방 기타 홈페이지 배너 광고 방해 행위 등을 할 수 없습니다.</li>
    <li>
      5. 회사는 서비스 이용 중 필요하다고 인정되는 다양한 마케팅 정보 등을 전자우편, 서신, SMS, 전화, 알림 메시지 (Push Notification) 및 회원의 연락처와 연동된 SNS 서비스 등의 방법으로
      회원에게 제공할 수 있으며, 회원은 이에 동의합니다. 이 경우 회원의 통신환경 또는 요금구조에 따라 회원이 데이터 요금 등을 부담할 수 있습니다. 회사는 수신거절을 위한 방법을 회원에게
      제공합니다.
    </li>
    <li>
      6. 회사는 서비스의 원활하고 안정적인 운영 및 서비스 품질의 개선을 위하여 회원의 개인정보를 제외한 이용자의 모바일 기기 정보(설정, 사양, 운영 체제, 버전 등)를 수집ㆍ활용할 수 있습니다.
    </li>
  </ol>
  <strong>제 17조 (저작권의 귀속 및 이용제한)</strong>
  <ol>
    <li>
      1. 회사가 제공하는 서비스 및 부동산정보서비스에 대한 저작권 및 지적재산권은 회사의 자산입니다. 단, 회원이 서비스 이용과정에서 작성한 저작물에 대한 저작권은 해당 회원에게 귀속됩니다.
    </li>
    <li>
      2. 회원은 자신이 생산하여 플랫폼에 제공한 콘텐츠에 대한 저작권을 갖습니다. 회원은 “회사”가 서비스 범위 내에서 콘텐츠를 이용하는 것에 동의합니다. 다만, 회원이 서비스 내에 게시한
      게시물에 대하여 제3자로부터 저작권 침해 등의 주장이 제기되거나 위법하다고 판단될 경우, “회사”는 회원의 동의 없이 게시물을 삭제할 수 있습니다.
    </li>
    <li>
      3. 회원이 서비스 내에 게시하는 게시물은 “회사”가 운영하는 다른 서비스의 회원에게 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서 게시물이 일부 수정, 복제, 편집될 수 있습니다. 이
      경우 회원은 “회사”에게 해당 게시물 삭제 또는 비공개 등의 조치를 요청할 수 있습니다.
    </li>
    <li>
      4. 회사는 서비스 제공을 위하여 회원이 플랫폼에 제공한 콘텐츠를 사용, 저장, 수정, 복제, 공중송신, 전시, 공표, 공연, 전송, 배포, 방송, 2차적 저작물 작성 등 어떠한 형태로든 이용 가능하며,
      이용기간과 지역에는 제한이 없습니다. 단 회사는 회원의 개인정보를 관련 법령에 따라 보호합니다.
    </li>
    <li>
      5. 회원은 회사가 제공하는 서비스 및 부동산정보서비스를 이용하는 과정에서 얻은 정보 중 회사에게 지적재산권이 귀속된 정보를 회사의 사전 승낙이 없이 복제, 송신, 출판, 배포, 방송 기타
      방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
    </li>
    <li>
      6. 회사는 회원이 관계법령을 위반하거나 이 약관을 위반하는 행위를 한 경우에는 회원이 이용중인 유료서비스를 해지하거나 제6조에 따른 회원가입을 직권 해지할 수 있으며, 유료서비스 해지 시
      환불은 해당 유료서비스 상품 약관에 정한 환불 규정을 따릅니다.
    </li>
    <li>
      7. 회원은 서비스를 이용함으로써 얻은 정보 중 제휴사에게 지적재산권이 귀속된 정보를 제휴사의 사전승낙 없이 복제, 송신, 출판, 배포, 방송, 기타 방법에 의하여 영리목적으로 이용하거나
      제3자에게 이용하게 하여서는 안 되며, 제휴사의 지적재산권이 귀속된 정보를 무단으로 사용하여 발생하는 법적 분쟁에 대해서는 각 제휴사가 정한 약관을 따릅니다.
    </li>
    <li>8. 제휴사 제공 정보에 대한 회원의 의무와 제휴사 제공 서비스에 대한 정보이용범위 및 지적재산권 등의 이해관계는 각 사의 약관이 정한 바에 따릅니다.</li>
    <li>
      9. 본 조는 회사가 서비스를 운영하는 동안 유효하며, 콘텐츠 공급자가 서비스 사용을 중단하거나, 해지하거나, 회원 탈퇴 후에도 지속적으로 적용됩니다. 회사는 이 권리를 서비스의 운영, 개선,
      홍보 그리고 새로운 서비스를 개발하기 위한 범위 내에서 사용합니다.
    </li>
  </ol>
  <strong>제 18조 (계약 해지 등)</strong>
  <ol>
    <li>
      1. 회원은 언제든지 회사가 제공하는 서비스에서 이용중인 유료서비스의 계약 해지 신청을 할 수 있으며, 회사는 관련법과 해당 유료서비스의 약관 등이 정하는 바에 따라 이를 즉시 처리하여야
      합니다.
    </li>
    <li>2. 회사는 전항에 따라 회원이 이용중인 유료서비스의 계약을 해지하는 경우, 상품 및 유료서비스의 환불정책에 따라 처리됩니다.</li>
    <li>
      3. 회사와 회원은 상대방이 다음 각 호의 하나에 해당하는 경우, 상대방에게 10일 이상의 시정기간을 두고 각 위반사항의 시정을 요구할 수 있으며, 그 기간 동안 시정이 이루어지지 않을 경우
      별도의 조치 없이 회원이 이용하고 있던 유료서비스의 계약을 해제 또는 해지할 수 있습니다. 단, 제②호 내지 제⑤호의 경우는 시정기간을 두지 않고 즉시 해제 또는 해지할 수 있습니다.
      <ol>
        <li>① 이 약관의 의무 또는 회사가 정한 매물관리 운영정책에 따른 허위매물관리규정 등을 이행하지 않거나 위반하여 서면통지로써 그 시정을 요구하였으나, 시정이 이루어지지 아니한 경우</li>
        <li>② 당사자 일방에 대하여, 국세 또는 지방세의 체납 처분, 파산신청, 회사정리절차 개시신청 등의 절차가 진행되는 경우</li>
        <li>③ 당사자 일방이 은행의 여신의 규제를 받거나 제3자에게 발행한 수표 또는 어음이 부도 또는 거래 정지된 경우</li>
        <li>④ 당사자 일방이 제3자로부터 각 당사자의 사업수행을 위한 주요 재산에 대해여 압류, 가압류, 가처분 및 강제집행 처분을 받아 각자의 주된 사업의 영위가 객관적으로 불가능할 경우</li>
        <li>⑤ 정부기관의 정책 변경 및 관련법령의 개정에 의한 영업허가나 사업자 등록의 취소 등에 의하여 계속적인 계약관계를 유지할 수 없음이 객관적으로 명백한 경우</li>
        <li>⑥ 회사의 확인 결과 회원이 휴업 또는 폐업한 경우</li>
        <li>⑦ 당사자 일방이 상대방의 이미지와 명예를 실추시키거나, 상대방에게 재산상 손실을 발생시킨 경우</li>
      </ol>
    </li>
  </ol>
  <strong>제 19조 (환불규정)</strong>
  <p class="text">사업자 휴∙폐업 등을 포함한 회원의 귀책사유 내지는 회원의 요청으로 본 약관에 의한 계약을 해제 또는 해지하는 경우 아래 각 호를 적용합니다.</p>
  <ol>
    <li>1. 멤버십 시작일 전에는 전액 환불합니다.</li>
    <li>2. 멤버십 시작일 이후에는 회사 담당 부서의 확인 후 사용기간에 따라 환불하며 결제액의 10%를 위약금으로 차감합니다.</li>
    <li>3. 회사는 결제한 결제수단을 취소하거나, 취소가 안 되는 경우 현금으로 환급해 줄 수 있습니다.</li>
  </ol>
  <strong>제 20조 (통합회원 탈퇴정책)</strong>
  <ol>
    <li>1. 회원은 언제든지 회사에 해지의사를 표시함으로써 일부 또는 전체서비스의 이용계약을 종료할 수 있습니다.</li>
    <li>2. 해지 의사표시는 회사가 정한 방식과 절차에 따라 진행됩니다.</li>
    <li>3. 회원은 탈퇴 전 회사에서 제공하는 서비스와 관련된 모든 절차를 완료, 철회 또는 취소하여야 합니다.</li>
    <li>4. 회원은 탈퇴 후 서비스 재가입에 제한이 없습니다. 단 기존 약관 및 서비스 운영정책 위반으로 이용정지 된 상태에서 탈퇴한 회원의 경우 재가입에 일부 제한이 따를 수 있습니다.</li>
    <li>
      5. 회원 탈퇴 시 모임장인 경우 양도 및 정리를 하고, 사업장에 소속된 일반회원은 사업장 멤버 탈퇴가 선행되어야 하고, 사업자회원의 대표는 검증 중 또는 노출 중인 매물을 모두 종료하고 멤버십
      및 충전금을 모두 환불받아야 하며, 소속멤버 또한 모두 정리 후 통합회원 탈퇴가 가능합니다.
    </li>
    <li>
      6. 회사는 다음 각 호에 해당하는 경우 회원과의 이용계약 해지를 요청할 수 있습니다.
      <ol>
        <li>① 통합회원가입 및 서비스 이용신청 과정에서 취득한 사항이 허위로 드러난 경우</li>
        <li>② 관계법령 및 동 약관의 의무사항을 위반한 경우</li>
        <li>③ 유료서비스 이용 과정에서 이용요금을 납부하지 않은 경우</li>
        <li>④ 회사의 운영 또는 유지·관리에 현저한 지장을 준다고 판단되는 경우</li>
      </ol>
    </li>
    <li>7. 회사가 본 조 제6항에 의하여 회원과의 이용계약을 해지하는 경우, 회사는 회원에게 가입시 취득된 휴대폰번호, 대표 연락처, 이메일, 전화, 문자 등을 통하여 통지합니다.</li>
    <li>8. 회사는 본 조 제7항의 해지의사 통지발송 전, 회원에게 당 해지사유에 대한 의견진술의 기회를 부여합니다.</li>
    <li>
      9. 이용계약이 해지된 경우, 회사는 당해 회원의 개인정보를 파기합니다. 단, 유료서비스 이용과 관련된 정보는 관계 법령에 따라 법령이 정한 일정한 기간 동안 정보를 보관합니다. 이때, 보관하는
      정보는 보관 목적 이외의 용도로 이용하지 아니합니다.
    </li>
    <li>10. 회원 탈퇴와 관련하여 개인정보 보유기간은 회원 탈퇴 후 12개월, 매물정보는 15개월입니다.</li>
  </ol>
  <strong>제 21조 (서비스의 변경 및 통지)</strong>
  <ol>
    <li>
      1. 회사는 회사에서 제공하는 서비스 내용, 품질 또는 기술적 사양 등을 성능 개선, 기능 변경, 불법적인 활동 방지 등을 위하여 변경할 수 있습니다. 이 경우에는 변경되는 중요한 서비스의 내용을
      명시하여 제공일자로부터 15일 전에 미리 각 서비스의 웹/앱 서비스 공지사항 게시판에 공지합니다. 단, 변경 내용이 회원에게 불리한 변경인 경우에는 적용일자 30일 이전까지 회원에게 본 조 또는
      제24조에서 정한 방법으로 통지합니다.
    </li>
    <li>
      2. 회사는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관계 법령에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.
    </li>
    <li>
      3. 회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 이용자가 알아볼 수 있도록 서비스에 공지합니다. 다만, 서비스설비의 정기점검 등의 사유로 회사가 서비스를
      특정범위로 분할하여 별도로 서비스 이용 가능 날짜와 시간을 정할 수 있습니다.
    </li>
    <li>4. 회사는 서비스에 필요한 소프트웨어의 업데이트 버전을 제공할 수 있습니다. 소프트웨어의 업데이트에는 중요한 기능의 추가 또는 불필요한 기능의 제거 등이 포함됩니다.</li>
    <li>5. 회사는 정책에 따라 회원 간의 차별화된 유료 서비스를 제공할 수 있습니다. 회원은 전항의 변경 내용에 동의하지 않을 경우 이용계약의 해지를 요청할 수 있습니다.</li>
  </ol>
  <strong>제 22조 (서비스의 중단)</strong>
  <ol>
    <li>
      1. 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우, 회사에서 제공하는 서비스 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는
      제 22조에서 정한 방법으로 회원에게 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
    </li>
    <li>2. 회사는 전항에 따른 서비스의 중단으로 인해 발생한 회원의 손해에 대해서 고의 또는 과실이 없는 한 책임을 부담하지 않습니다.</li>
  </ol>
  <strong>제 23조 (회원에 대한 통지)</strong>
  <ol>
    <li>1. 회사가 회원에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 전자우편, 전자쪽지 또는 휴대전화 등으로 할 수 있습니다.</li>
    <li>
      2. 회사는 회원 전체에 대한 통지의 경우 7일 이상 각 서비스의 웹/앱 서비스 공지사항 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한
      영향을 미치는 사항에 대하여는 제1항의 통지를 합니다.
    </li>
  </ol>
  <strong>제 24조 (책임의 한계 등)</strong>
  <ol>
    <li>
      1. 회사는 천재지변, 불가항력, 서비스용 설비의 보수, 교체, 점검, 공사 등 기타 이에 준하는 사항으로 정보 및 서비스를 제공할 수 없는 경우에 회사의 고의 또는 과실이 없는 한 이에 대한
      책임이 면제됩니다. 단, 서비스 제공이 중단된 기간은 유료 서비스 기간에서 제외됩니다.
    </li>
    <li>2. 회사는 회원을 포함한 이용자의 귀책사유로 인한 정보 및 서비스 이용의 장애에 관하여 회사의 고의 또는 과실이 없는 한 책임을 지지 않습니다.</li>
    <li>3. 회사는 회원이 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 회사의 고의 또는 과실이 없는 한 책임을 지지 않습니다.</li>
    <li>
      4. 회사는 회사의 고의 또는 과실이 없는 한 매물정보를 등록한 회원에 의한 사기, 연락 불능 등으로 인하여 발생하는 어떠한 직접, 간접, 부수적, 파생적, 징벌적 손해, 손실, 상해 등에 대하여
      도덕적, 법적 책임을 부담하지 않습니다. 또한, 회사의 귀책사유가 없는 이상, 회사는 회원과 제3자간에 발생하는 부동산 거래 등에 대하여 회사는 어떠한 도덕적, 법적 책임이나 의무도 부담하지
      아니합니다.
    </li>
    <li>
      5. 회사에서 제공하는 데이터 및 분석자료는 회원의 투자 판단을 위한 참고 정보 제공을 목적으로 하며, 회사에서 제공하는 서비스는 관련 특정 부동산에 대한 구속적 투자 판단이나 투자 권유를
      구성하지 않습니다. 회사에서 제공하는 정보는 오류가 있을 수 있고, 서비스가 지연될 수도 있습니다. 투자 판단은 회원에게 있으며, 이로 인해 발생한 손실에 대해서는 회사는 책임지지 않습니다.
    </li>
    <li>
      6. 회사에서 제공하는 서비스 및 서비스를 이용하여 얻은 정보에 따른 투자는 손실이 발생할 수 있으며, 이에 대한 최종 판단은 이용자 자신이 하여야 하고, 그에 따른 책임은 전적으로 이용자
      자신에게 있으며, 회사는 그로 인하여 발생하는 손해에 대해서 어떠한 책임도 지지 않습니다.
    </li>
  </ol>
  <strong>제 25조 (준거법 및 재판관할)</strong>
  <ol>
    <li>1. 회사와 회원 간 제기된 소송은 대한민국법을 준거법으로 합니다.</li>
    <li>2. 회사와 회원간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.</li>
  </ol>
  <br />
  <p class="text">부칙</p>
  <p class="text">본 약관은 2024년 11월 05일부터 적용됩니다.</p>
  </div>
    `,
};

export const LOCATION_INFO = {
  title: '위치기반 서비스 이용약관',
  content: `
  <div class="personalInfoWrap terms">
     <strong>제 1조 (목적) </strong>
     <p class="text">본 약관은 회원(프롭티어 서비스 약관에 동의한 개인위치정보주체를 말합니다. 이하 “회원”이라고 합니다.) 프롭티어(주)(이하 “회사”라고 합니다.)가 제공하는 이실장, 이실장넷, 이실장플러스 서비스(이하 “서비스”라고 합니다)를 이용함에 있어 회사와 회원의 권리·의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

     <strong>제2조(이용약관의 효력 및 변경) </strong>
     <ol>
         <li>고객은 회사의 서비스를 이용하고자 하는 경우, 약관의 고지 내용에 따라 개인위치정보 서비스에 가입하게 됩니다. 회원의 경우 서비스 이용시 동의절차를 밟습니다.</li>
         <li>본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사 소정의 절차에 따라 서비스의 이용자로 등록함으로써 효력이 발생합니다.</li>
         <li>회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하였을 경우 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며, 그 적용에 동의한 것으로 봅니다.</li>
         <li>회사는 위치기반서비스의 변경사항을 반영하기 위하여 필요한 경우 등에는 위치정보의 보호 및 이용 등에 관한 법률, 콘텐츠산업 진흥법, 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법, 약관의 규제에 관한 법률 등 관련법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
         <li>회사가 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 아래 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 이 약관의 중대한 변경이거나 회원에게 불리한 변경인 경우에는 적용일자 30일 이전까지 이를 공지 하고 회원에게 통지하도록 합니다.<br>- 회원에 대한 통지 방식<span class="indent">-서비스 홈페이지 등 게시</span><span class="indent">-회원에게 전자적 형태(전자우편, SMS 등)로 개별 통지</span></li>
         <li>회사의 전항에 따른 게시 및 통지 후에도 회원이 개정약관 적용일까지 개정약관에 대해 동의 또는 거부의 의사표시를 하지 않을 때에는 회원이 해당 개정약관에 동의한 것으로 봅니다.</li>
         <li>회원이 개정약관에 동의하지 않을 경우 (회사 또는) 회원은 이용계약을 해지할 수 있습니다. 이 때, 회사는 계약해지로 인하여 회원이 입은 손해를 배상합니다.</li>
     </ol>

     <strong>제3조(관계법령의 적용) </strong>
     <p class="text">본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계법령 또는 상관례에 따릅니다.</p>

     <strong>제4조(서비스의 내용 등) </strong>
     <ol>
       <li>1. 회사가 제공하는 위치정보 서비스는 무료입니다.  단, 무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다. </li>
       <li>
           2. 회사가 제공하는 위치기반서비스는 아래와 같으며, 7조 2항에 따라 위치정보를 보관하지 아니한다.
           <br/>
           <span class="indent"><b class="fw-b">[이실장 플러스]</b> aipartner.plus > 내 위치</span><br/>
           <span class="indent">- 서비스 내용 및 (보유)목적 : 현재 위치기반 주변 정보 제공 </span><br/><br/>
           <span class="indent"><b class="fw-b">[집찍고]</b> 집찍고 앱 사진 촬영 시</span><br/>
           <span class="indent">- 서비스 내용 및 (보유)목적 : 사진 파일 내 GPS 위치정보 제공 </span> <br/>
         </li>
     </ol>
     <strong>제5조(서비스 추가·변경) </strong>
     <p class="text">회사가 서비스의 추가·변경이 필요한 경우, 제4조에 그 내용을 반영하며, 제2조 제4항 내지 제5항에 따라 게시 및 통지하여야 합니다.</p>

     <strong>제6조(서비스이용의 제한 및 중지) </strong>
     <ul>
         <li>① 회사는 아래 각 호에 해당하는 사유가 발생한 경우 서비스의 일부 혹은 전부의 이용을 제한하거나 중지할 수 있습니다.<ol>
                 <li>회원이 회사 서비스의 운영을 고의 또는 중과실로 방해하는 경우</li>
                 <li>서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우</li>
                 <li>전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우</li>
                 <li>국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때</li>
                 <li>기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우</li>
             </ol>
         </li>
         <li>② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 공지를 통해 사전에 통지합니다.</li>
         <li>③ 회사가 전항에 따른 게시 및 통지를 할 수 없는 부득이한 사유가 있는 경우 사후에 게시 및 통지할 수 있습니다.</li>
     </ul>

     <strong>제7조(개인위치정보의 이용 또는 제공) </strong>
     <ul>
         <li>① 회사는 이용자의 개인위치정보를 이용하여 서비스를 제공할 수 있고 이용자는 이에 동의한다. 회사는 이용자와의 민원처리를 위해 개인위치정보 이용 동의 사실에 관한 자료를 회원 탈퇴 또는 정보 주체의 삭제요구시 까지 보관한다.</li>
         <li>② 회사가 이용하는 정보는 이용자가 이 서비스를 요청한 시점의 통신단말장치의 GPS 또는 기지국좌표 등의 위치정보이며, 이 외 이용자 개인에 대한 정보는 이용 또는 수집하지 않는다. 이용된 통신단말장치의 위치정보는 이 서비스 목적 이외 다른 용도로는 사용하지 않으며, 회사의 시스템에 저장하지 않는다.</li>
         <li>③ 회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조 제2항에 따라 위치정보 이용∙제공사실 확인자료를 자동 기록∙보존하며, 해당 자료는 1년간 보관한다.</li>
         <li>④ 회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 이용약관에 명시한 후 개인위치정보주체의 동의를 얻어야 합니다.</li>
         <li>⑤ 회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 제공받는 자 및 제공목적을 사전에 회원에게 고지하고 동의를 받습니다.</li>
         <li>⑥ 제2항에 따라 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 해당 통신 단말장치 또는 전자우편주소 등으로 매회 회원에게 제공받는 자, 제공일시 및 제공목적(이하 “정보제공내역”이라 합니다)을 즉시 통보합니다.</li>
         <li>⑦단, 아래 각 호에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통보합니다.<ol>
                 <li>개인위치정보를 수집한 해당 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우</li>
                 <li>회원이 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우</li>
             </ol>
         </li>
         <li>⑧ 제3항에도 불구하고 회원은 위치정보법 시행령 제24조에 따라 정보제공내역을 (10일마다 또는 10회씩) 모아서 통보받는 방법을 선택할 수 있으며, 회원이 회사의 절차에 따라 요청할 경우 전항에 따른 즉시 통보 방법으로 변경할 수 있습니다.</li>
         <li>⑨ 회원은 제1항·제2항·제5항에 따른 동의를 하는 경우 이용·제공목적, 제공받는 자의 범위 및 위치기반서비스 이용약관의 내용 중 일부와 회원의 개인위치정보에 대한 제3자 제공의 경우 통보방법에 대하여 동의를 유보할 수 있습니다.</li>
     </ul>

     <strong>제8조(개인위치정보의 이용 또는 제공의 제한) </strong>
     <p class="text">회사는 회원의 동의가 있거나 다음 각 호의 어느 하나에 해당하는 경우를 제외하고는 개인위치정보 또는 위치정보 이용·제공사실 확인자료를 이용약관에 명시 또는 고지한 범위를 넘어 이용하거나 제3자에게 제공할 수 없습니다.</p>
     <ol>
         <li>이용자의 동의가 있는 경우</li>
         <li>위치기반서비스의 제공에 따른 요금정산을 위하여 위치정보 이용·제공사실 확인자료가 필요한 경우</li>
         <li>통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우</li>
         <li>그 밖에 「위치정보의 보호 및 이용 등에 관한 법률」 등 관련 법령에서 정한 경우</li>
     </ol>

     <strong>제9조(개인위치정보주체의 권리 및 행사방법) </strong>
     <ul>
         <li>① 회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회 할 수 있습니다. 이 경우 회사는 제공받은 개인위치정보 이용 동의 사실에 관한 자료를 파기합니다.</li>
         <li>② 회원은 회사에 대하여 언제든지 개인위치정보의 이용 또는 제공의 일시적인 중지를 요구할 수 있고, 회사는 이를 거절할 수 없으며 이를 위한 기술적 수단을 갖추고 있습니다.</li>
         <li>③ 회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 해당 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절할 수 없습니다.<ol>
                 <li>본인에 대한 위치정보 이용, 제공사실 확인자료</li>
                 <li>본인의 개인위치정보가 위치정보의 보호 및 이용 등에 관한 법률 또는 다른 법률 규정에 의하여 제3자에게 제공된 이유 및 내용</li>
             </ol>
         </li>
         <li>④ 회원은 제1항 내지 제3항의 권리행사를 위해 (고객센터 등 구체적 절차 기술)를 통해 요구할 수 있습니다.</li>
     </ul>

     <strong>제10조(법정대리인의 권리 및 행사방법) </strong>
     <ul>
         <li>① 회사는 14세 미만의 회원의 경우, 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대하여 해당 회원과 그 법정대리인 모두의 동의를 받아야 합니다. 이 경우 법정대리인은 제10조에 의한 회원의 권리를 모두 가집니다.</li>
         <li>② 회사는 다음 각 호의 어느 하나에 해당하는 방법으로 법정대리인이 동의했는지를 확인합니다.<ol>
                 <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 위치정보사업자등이 그 동의 표시를 확인했음을 법정대리인의 휴대전화 문자메시지로 알리는 방법</li>
                 <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 신용카드ㆍ직불카드 등의 카드정보를 제공받는 방법</li>
                 <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 휴대전화 본인인증 등을 통해 본인 여부를 확인하는 방법</li>
                 <li>동의 내용이 적힌 서면을 법정대리인에게 직접 발급하거나, 우편 또는 팩스를 통하여 전달하고 법정대리인이 동의 내용에 대하여 서명날인 후 제출하도록 하는 방법</li>
                 <li>동의 내용이 적힌 전자우편을 발송하여 법정대리인으로부터 동의의 의사표시가 적힌 전자우편을 전송받는 방법</li>
                 <li>전화를 통하여 동의 내용을 법정대리인에게 알리고 동의를 얻거나 인터넷주소 등 동의 내용을 확인할 수 있는 방법을 안내하고 재차 전화 통화를 통하여 동의를 얻는 방법</li>
                 <li>그 밖에 제1호부터 제6호까지의 규정에 따른 방법에 준하는 방법으로 법정대리인에게 동의 내용을 알리고 동의의 의사표시를 확인하는 방법</li>
             </ol>
         </li>
     </ul>

     <strong>제11조(8세 이하의 아동 등의 보호의무자의 권리･의무 및 행사방법) </strong>
     <ul>
         <li>① 회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동”등이라 한다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.<ol>
                 <li>8세 이하의 아동</li>
                 <li>피성년후견인</li>
                 <li>「장애인복지법」제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서「장애인고용촉진 및 직업재활법」 제2조제2호의 규정에 의한 중증장애인에 해당하는 자(「장애인복지법」 제32조의 규정에 의하여 장애인등록을 한 자에 한한다)</li>
             </ol>
         </li>
         <li>② 제1항에 따른 8세 이하의 아동등의 보호의무자는 8세 이하의 아동등을 사실상 보호하는 자로서 다음 각 호의 어느 하나에 해당하는 자를 말합니다.<ol>
                 <li>8세 이하의 아동의 법정대리인 또는 「보호시설에 있는 미성년자의 후견 직무에 관한 법률」 제3조에 따른 후견인</li>
                 <li>피성년후견인의 법정대리인</li>
                 <li>제1항제3호의 자의 법정대리인 또는 「장애인복지법」 제58조제1항제1호에 따른 장애인 거주시설(국가 또는 지방자치단체가 설치ㆍ운영하는 시설로 한정한다)의 장, 「정신건강증진 및 정신질환자 복지서비스 지원에 관한 법률」 제22조에 따른 정신요양시설의 장 및 같은 법 제26조에 따른 정신재활시설(국가 또는 지방자치단체가 설치ㆍ운영하는 시설로 한정한다)의 장</li>
             </ol>
         </li>
         <li>③ 제1항에 따른 동의를 하고자 하는 8세 이하 아동 등의 보호의무자는 각 호의 사항을 기재하여 기명날인 또는 서명한 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.<ol>
                 <li>8세 이하의 아동등의 성명, 주소 및 생년월일</li>
                 <li>보호의무자의 성명, 주소 및 연락처</li>
                 <li>개인위치정보 이용 또는 제공의 목적이 8세 이하의 아동등의 생명 또는 신체의 보호에 한정된다는 사실</li>
                 <li>동의의 연월일</li>
             </ol>
         </li>
         <li>④ 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 제10조에 의한 회원의 권리 전부를 행사할 수 있습니다.</li>
     </ul>

     <strong>제12조 (위치정보관리책임자의 지정) </strong>
     <ul>
         <li>① 회사는 위치정보를 적절히 관리․보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 위치정보관리책임자로 지정해 운영합니다.</li>
         <li>② 위치정보관리책임자는 위치기반서비스를 제공하는 부서의 부서장으로서 구체적인 사항은 본 약관의 부칙에 따릅니다.</li>
     </ul>

     <strong>제13조(손해배상) </strong>
     <ul>
         <li>① 개인위치정보주체는 회사의 다음 각 호에 해당하는 행위로 손해를 입은 경우에 회사에 대해 손해배상을 청구할 수 있습니다. 이 경우 개인위치정보주체는 회사의 고의 또는 과실이 있음을 직접 입증하여야 합니다.<ol>
                 <li>법령에서 허용하는 경우를 제외하고 이용자 또는 개인위치정보주체의 동의 없이 위치정보를 수집, 이용하는 행위</li>
                 <li>개인위치정보의 누출, 변조, 훼손 등의 행위</li>
             </ol>
         </li>
         <li>② 회사는 천재지변 등 불가항력적인 사유나 이용자의 고의 또는 과실로 인하여 발생한 때에는 손해를 배상하지 아니합니다.</li>
         <li>③ 회사는 이용자가 망사업자의 통신환경에 따라 발생할 수 있는 오차 있는 위치정보를 이용함으로써 이용자 및 제3자가 입은 손해에 대하여는 배상하지 아니합니다.</li>
     </ul>

     <strong>제14조(준거법 및 재판관할) </strong>
     <ul>
         <li>① 본 약관은 대한민국법령에 의하여 규정되고 이행됩니다.</li>
         <li>② 회원 및 법정대리인의 권리와 그 행사방법은 제소 당시의 이용자의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.</li>
     </ul>

     <strong>제15조(분쟁의 조정 및 기타) </strong>
     <ul>
         <li>① 회사는 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 「위치정보의 보호 및 이용 등에 관한 법률」 제28조의 규정에 의해 방송통신위원회에 재정을 신청할 수 있습니다.</li>
         <li>② 회사 또는 회원은 위치정보와 관련된 분쟁에 대해 당사자간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 「개인정보보호법」 제43조의 규정에 의한 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.</li>
     </ul>

     <strong>제16조(회사의 연락처) </strong>
     <p class="text">회사의 상호 및 주소 등은 다음과 같습니다.</p>
     <ol>
         <li>상 호 : 프롭티어(주)</li>
         <li>대 표 자 : 서동록</li>
         <li>주 소 : 서울 서초구 방배로 107</li>
         <li>대표전화 : 02-597-2799</li>
     </ol>

     <strong>부 칙 </strong>
     <p>제1조(시행일) 이 약관은 2024년 08월 06일부터 시행한다.</p>
     <p class="text">제2조 위치정보관리책임자는 2024년 01월 기준으로 다음과 같이 지정합니다.</p>
     <ol>
         <li>소 속 : 프롭티어(주) 서비스 개발 파트</li>
         <li>이 름 : 한대규</li>
         <li>직 급 : PL</li>
     </ol>

 </div>

    `,
};
